var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSugarImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2269 1438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-3);}.cls-2,.cls-4{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);filter:url(#luminosity-noclip-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#91b3fa;}.cls-13,.cls-7,.cls-83{fill:#fff;}.cls-7{opacity:0.48;}.cls-8{fill:#bdd0fb;}.cls-9{fill:#7d97f4;}.cls-10{fill:#2b69b3;}.cls-11{fill:#18174a;}.cls-12{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-5);}.cls-15{fill:url(#linear-gradient-6);}.cls-16{fill:url(#linear-gradient-7);}.cls-17{fill:url(#linear-gradient-8);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{fill:url(#linear-gradient-26);}.cls-36{fill:url(#linear-gradient-27);}.cls-37{fill:url(#linear-gradient-28);}.cls-38{fill:url(#linear-gradient-29);}.cls-39{fill:url(#linear-gradient-30);}.cls-40{fill:url(#linear-gradient-31);}.cls-41{fill:url(#linear-gradient-32);}.cls-42{fill:url(#linear-gradient-33);}.cls-43{fill:url(#linear-gradient-34);}.cls-44{fill:url(#linear-gradient-35);}.cls-45{fill:url(#linear-gradient-36);}.cls-46{fill:url(#linear-gradient-37);}.cls-47{fill:url(#linear-gradient-38);}.cls-48{fill:url(#linear-gradient-39);}.cls-49{fill:url(#linear-gradient-40);}.cls-50{fill:url(#linear-gradient-41);}.cls-51{fill:url(#linear-gradient-42);}.cls-52{fill:url(#linear-gradient-43);}.cls-53{fill:url(#linear-gradient-44);}.cls-54{fill:url(#linear-gradient-45);}.cls-55{mask:url(#mask-3);}.cls-56,.cls-62{opacity:0.71;}.cls-56{fill:url(#linear-gradient-46);}.cls-57{fill:url(#linear-gradient-47);}.cls-58{fill:url(#linear-gradient-48);}.cls-59{fill:url(#linear-gradient-49);}.cls-60{fill:url(#linear-gradient-50);}.cls-61{mask:url(#mask-4);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64{fill:url(#linear-gradient-53);}.cls-65{fill:url(#linear-gradient-54);}.cls-66{fill:url(#linear-gradient-55);}.cls-67{fill:url(#linear-gradient-56);}.cls-68{fill:url(#linear-gradient-57);}.cls-69{fill:url(#linear-gradient-58);}.cls-70{fill:url(#linear-gradient-59);}.cls-71{fill:url(#linear-gradient-60);}.cls-72{fill:url(#linear-gradient-61);}.cls-73{fill:url(#linear-gradient-62);}.cls-74{fill:url(#linear-gradient-63);}.cls-75{fill:url(#linear-gradient-64);}.cls-76{fill:url(#linear-gradient-65);}.cls-77{fill:url(#linear-gradient-66);}.cls-78{fill:url(#linear-gradient-67);}.cls-79{fill:url(#linear-gradient-68);}.cls-80{fill:url(#linear-gradient-69);}.cls-81{fill:#f7f4f9;}.cls-82{opacity:0.64;}.cls-83{opacity:0.56;}.cls-84{fill:url(#linear-gradient-70);}.cls-85{fill:url(#linear-gradient-71);}.cls-86{fill:url(#linear-gradient-72);}.cls-87{fill:url(#linear-gradient-73);}.cls-88{fill:url(#linear-gradient-74);}.cls-89{fill:url(#linear-gradient-75);}.cls-90{fill:url(#linear-gradient-76);}.cls-91{fill:url(#linear-gradient-77);}.cls-92{fill:url(#linear-gradient-78);}.cls-93{fill:url(#linear-gradient-79);}.cls-94{fill:url(#linear-gradient-80);}.cls-95{fill:url(#linear-gradient-81);}.cls-96{fill:url(#linear-gradient-82);}.cls-97{fill:url(#linear-gradient-83);}.cls-98{fill:url(#linear-gradient-84);}.cls-99{fill:url(#linear-gradient-85);}.cls-100{fill:url(#linear-gradient-86);}.cls-101{fill:url(#linear-gradient-87);}.cls-102{fill:url(#linear-gradient-88);}.cls-103{fill:url(#linear-gradient-89);}.cls-104{fill:url(#linear-gradient-90);}.cls-105{fill:url(#linear-gradient-91);}.cls-106{fill:url(#linear-gradient-92);}.cls-107{fill:url(#linear-gradient-93);}.cls-108{fill:url(#linear-gradient-94);}.cls-109{fill:url(#linear-gradient-95);}.cls-110{fill:url(#linear-gradient-96);}.cls-111{fill:url(#linear-gradient-97);}.cls-112{fill:url(#linear-gradient-98);}.cls-113{fill:url(#linear-gradient-99);}.cls-114{fill:url(#linear-gradient-100);}.cls-115{fill:url(#linear-gradient-101);}.cls-116{fill:url(#linear-gradient-102);}.cls-117{fill:url(#linear-gradient-103);}.cls-118{fill:url(#linear-gradient-104);}.cls-119{fill:url(#linear-gradient-105);}.cls-120{fill:url(#linear-gradient-106);}.cls-121{fill:url(#linear-gradient-107);}.cls-122{fill:url(#linear-gradient-108);}.cls-123{fill:url(#linear-gradient-109);}.cls-124{fill:url(#linear-gradient-110);}.cls-125{fill:url(#linear-gradient-111);}.cls-126{fill:url(#linear-gradient-112);}.cls-127{fill:url(#linear-gradient-113);}.cls-128{fill:url(#linear-gradient-114);}.cls-129{fill:url(#linear-gradient-115);}.cls-130{fill:url(#linear-gradient-116);}.cls-131{fill:url(#linear-gradient-117);}.cls-132{fill:url(#linear-gradient-118);}.cls-133{fill:url(#linear-gradient-119);}.cls-134{filter:url(#luminosity-noclip-2);}.cls-135{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 755.73,
    y: -8908,
    width: 129.7,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 755.73,
    y: -8908,
    width: 129.7,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 788.48,
    y1: 1090.44,
    x2: 971.38,
    y2: 1136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 904.62,
    y: -8908,
    width: 129.7,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 904.62,
    y: -8908,
    width: 129.7,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 8132.53,
    y1: 1090.44,
    x2: 8315.43,
    y2: 1136,
    gradientTransform: "matrix(-1, 0, 0, 1, 9134.11, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.03,
    y1: 666.6,
    x2: 2235.65,
    y2: 666.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 945.47,
    y1: 650.33,
    x2: 1248.9,
    y2: 650.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 314.21,
    y1: 1033.44,
    x2: 677.4,
    y2: 1033.44,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 314.21,
    y1: 1049.99,
    x2: 677.4,
    y2: 1049.99,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 314.21,
    y1: 1066.54,
    x2: 677.4,
    y2: 1066.54,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 314.21,
    y1: 1083.09,
    x2: 677.4,
    y2: 1083.09,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 314.21,
    y1: 1099.64,
    x2: 677.4,
    y2: 1099.64,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 252.34,
    y1: 806.52,
    x2: 566.82,
    y2: 806.52,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 259.72,
    y1: 819.34,
    x2: 566.82,
    y2: 819.34,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 263.51,
    y1: 828.78,
    x2: 566.82,
    y2: 828.78,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 776.19,
    y1: 625.06,
    x2: 636.48,
    y2: 769.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 590.81,
    y1: 354.92,
    x2: 1231.04,
    y2: 354.92,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 582.16,
    y1: 402.42,
    x2: 1222.39,
    y2: 402.42,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 582.16,
    y1: 451.41,
    x2: 1222.39,
    y2: 451.41,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 587.68,
    y1: 493.47,
    x2: 1227.9,
    y2: 493.47,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 971.91,
    y1: 533.29,
    x2: 1226.71,
    y2: 533.29,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 586.49,
    y1: 539.45,
    x2: 765.31,
    y2: 539.45,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 975.84,
    y1: 580.8,
    x2: 1218.07,
    y2: 580.8,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 577.84,
    y1: 587.04,
    x2: 754.66,
    y2: 587.04,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 975.84,
    y1: 629.79,
    x2: 1218.07,
    y2: 629.79,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 577.84,
    y1: 636.19,
    x2: 750.9,
    y2: 636.19,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 975.84,
    y1: 671.85,
    x2: 1223.58,
    y2: 671.85,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 583.35,
    y1: 678.33,
    x2: 754.66,
    y2: 678.33,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1253.29,
    y1: 1298.25,
    x2: 1226.29,
    y2: 1477.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1339.49,
    y1: 1183.46,
    x2: 1288.49,
    y2: 1231.46,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1228.86,
    y1: 1212.5,
    x2: 1426.68,
    y2: 1212.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 512.64,
    y1: 1341.78,
    x2: 523.11,
    y2: 1341.78,
    gradientTransform: "translate(1035.75 2683.55) rotate(-180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 471.99,
    y1: 1397.2,
    x2: 563.76,
    y2: 1397.2,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 458.37,
    y1: 1276.1,
    x2: 573.75,
    y2: 1276.1,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 606.18,
    y1: 1297.6,
    x2: 511.51,
    y2: 1380.26,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 657.09,
    y1: 1141.1,
    x2: 650.43,
    y2: 1219.1,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 917.79,
    y1: 1389.53,
    x2: 878.46,
    y2: 1474.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 892.01,
    y1: 1367.82,
    x2: 916.71,
    y2: 1367.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 932.35,
    y1: 1351.17,
    x2: 911.68,
    y2: 1418.5,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 881.76,
    y1: 1422.06,
    x2: 948.18,
    y2: 1422.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 874.15,
    y1: 1390.62,
    x2: 897.33,
    y2: 1390.62,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 963.41,
    y1: 1184.46,
    x2: 906.38,
    y2: 1095.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 944.99,
    y1: 1123.28,
    x2: 1025.86,
    y2: 1123.28,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 935.24,
    y1: 960.9,
    x2: 870.24,
    y2: 1031.9,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 831.24,
    y1: 1124.26,
    x2: 625.81,
    y2: 1481.22,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1156.48,
    y1: 275.63,
    x2: 1158.48,
    y2: 211.63,
    gradientTransform: "matrix(0.92, 0.39, -0.39, 0.92, -367.37, 984.41)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1134.8,
    y1: 274.96,
    x2: 1136.8,
    y2: 210.96,
    gradientTransform: "matrix(0.92, 0.39, -0.39, 0.92, -367.37, 984.41)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 713.5,
    y1: 1128.93,
    x2: 895.29,
    y2: 1128.93,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 755.73,
    y: 1077.28,
    width: 129.7,
    height: 55.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 755.73,
    y: 1077.28,
    width: 129.7,
    height: 55.68,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M756,1108.26l47.2-27.79a6,6,0,0,1,1.76-.7c6.69-1.49,46.61-9.15,78.53,13a4.51,4.51,0,0,1,1.85,4.68l-7.42,33.8a2.23,2.23,0,0,1-3.49,1.32c-10.72-7.93-52.51-34.51-118.08-23.33A.51.51,0,0,1,756,1108.26Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 788.48,
    y1: 1090.44,
    x2: 971.38,
    y2: 1136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 727.22,
    y1: 1148.63,
    x2: 889.16,
    y2: 1148.63,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 728.3,
    y1: 1142.13,
    x2: 887.07,
    y2: 1142.13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 726.33,
    y1: 1154.24,
    x2: 887.07,
    y2: 1154.24,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 8057.55,
    y1: 1128.93,
    x2: 8239.34,
    y2: 1128.93,
    gradientTransform: "matrix(-1, 0, 0, 1, 9134.11, 0)",
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 904.62,
    y: 1077.28,
    width: 129.7,
    height: 55.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 904.62,
    y: 1077.28,
    width: 129.7,
    height: 55.68,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1034.07,1108.26l-47.2-27.79a5.9,5.9,0,0,0-1.77-.7c-6.69-1.49-46.61-9.15-78.53,13a4.54,4.54,0,0,0-1.85,4.68l7.42,33.8a2.23,2.23,0,0,0,3.5,1.32c10.72-7.93,52.5-34.51,118.08-23.33A.51.51,0,0,0,1034.07,1108.26Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 8132.53,
    y1: 1090.44,
    x2: 8315.43,
    y2: 1136,
    gradientTransform: "matrix(-1, 0, 0, 1, 9134.11, 0)",
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 902.98,
    y1: 1142.13,
    x2: 1061.76,
    y2: 1142.13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 902.98,
    y1: 1154.24,
    x2: 1063.73,
    y2: 1154.24,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1276.87,
    y1: 1145.85,
    x2: 1269.53,
    y2: 1212.18,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1177.29,
    y1: 1074.24,
    x2: 1143.67,
    y2: 1124.86,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1314.74,
    y1: 1027.59,
    x2: 1408.56,
    y2: 1231.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1304.38,
    y1: 954.56,
    x2: 1319.38,
    y2: 1068.56,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1356.47,
    y1: 901.62,
    x2: 1309.47,
    y2: 945.62,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1366.8,
    y1: 916.24,
    x2: 1319.8,
    y2: 960.24,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1366.9,
    y1: 1004.33,
    x2: 1352.9,
    y2: 1104.33,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 626.1,
    y1: 1197.18,
    x2: 632.56,
    y2: 1138.15,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 530.37,
    y1: 1112.81,
    x2: 476.37,
    y2: 1189.48,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 595.63,
    y1: 957.48,
    x2: 566.3,
    y2: 1040.15,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -762.77,
    y1: -89.12,
    x2: -744.11,
    y2: -39.12,
    gradientTransform: "matrix(-1, -0.06, -0.06, 1, 51.75, 505.02)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -552.48,
    y1: 777.02,
    x2: -533.81,
    y2: 827.02,
    gradientTransform: "matrix(-0.91, 0.41, 0.41, 0.91, -249.5, 352.42)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 554.94,
    y1: 1063.35,
    x2: 596.65,
    y2: 1305.87,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1711.23,
    y1: 3259.94,
    x2: 1735.92,
    y2: 3238.48,
    gradientTransform: "translate(2811.61 -1796.16) rotate(64.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 654.99,
    y1: 1065.63,
    x2: 638.32,
    y2: 1103.63,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 6565.3,
    y1: 1107.76,
    x2: 6338.61,
    y2: 1165.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 7021.08, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1648.07,
    y1: 597.11,
    x2: 738.84,
    y2: 1438.31,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1400.24,
    y1: 582.61,
    x2: 1925.69,
    y2: 582.61,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1400.04,
    y1: 479.41,
    x2: 1891.02,
    y2: 479.41,
    gradientTransform: "translate(2120.29 -1167.47) rotate(89.84)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1506.75,
    y1: 582.6,
    x2: 1509.83,
    y2: 582.6,
    gradientTransform: "translate(1.8 -4.63) rotate(0.18)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1817.57,
    y1: 581.56,
    x2: 1820.64,
    y2: 581.56,
    gradientTransform: "translate(1.8 -5.59) rotate(0.18)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1716.31,
    y1: 581.56,
    x2: 1719.39,
    y2: 581.56,
    gradientTransform: "translate(1.79 -5.28) rotate(0.18)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1611.22,
    y1: 581.56,
    x2: 1614.29,
    y2: 581.56,
    gradientTransform: "translate(1.79 -4.95) rotate(0.18)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1517.83,
    y1: 112.72,
    x2: 1487.83,
    y2: 306.21,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1522.93,
    y1: 113.51,
    x2: 1492.93,
    y2: 307,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1528.32,
    y1: 114.34,
    x2: 1498.32,
    y2: 307.83,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1534.52,
    y1: 115.3,
    x2: 1504.53,
    y2: 308.79,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1545.01,
    y1: 116.93,
    x2: 1515.01,
    y2: 310.42,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1618.7,
    y1: 128.36,
    x2: 1588.7,
    y2: 321.85,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1623.8,
    y1: 129.14,
    x2: 1593.8,
    y2: 322.64,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1635.39,
    y1: 130.94,
    x2: 1605.39,
    y2: 324.43,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1640.49,
    y1: 131.73,
    x2: 1610.49,
    y2: 325.22,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1645.88,
    y1: 132.57,
    x2: 1615.88,
    y2: 326.06,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1721.89,
    y1: 144.35,
    x2: 1691.89,
    y2: 337.84,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1726.98,
    y1: 145.14,
    x2: 1696.99,
    y2: 338.63,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1732.38,
    y1: 145.98,
    x2: 1702.38,
    y2: 339.47,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1743.68,
    y1: 147.73,
    x2: 1713.68,
    y2: 341.22,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1749.07,
    y1: 148.57,
    x2: 1719.07,
    y2: 342.06,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1821.49,
    y1: 159.8,
    x2: 1791.5,
    y2: 353.29,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1831.98,
    y1: 161.42,
    x2: 1801.98,
    y2: 354.91,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1838.18,
    y1: 162.38,
    x2: 1808.19,
    y2: 355.87,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1843.28,
    y1: 163.17,
    x2: 1813.28,
    y2: 356.66,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1848.67,
    y1: 164.01,
    x2: 1818.68,
    y2: 357.5,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1922.09,
    y1: 175.39,
    x2: 1892.1,
    y2: 368.88,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1927.19,
    y1: 176.18,
    x2: 1897.19,
    y2: 369.67,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1938.79,
    y1: 177.98,
    x2: 1908.79,
    y2: 371.47,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1949.27,
    y1: 179.61,
    x2: 1919.28,
    y2: 373.1,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1740.25,
    y1: 313.38,
    x2: 1602.58,
    y2: 496.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1790.72,
    y1: 210.3,
    x2: 1665.07,
    y2: 377.14,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1524.79,
    y1: 296.84,
    x2: 1389.02,
    y2: 584.44,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1630.27,
    y1: 296.84,
    x2: 1494.51,
    y2: 584.44,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1734.67,
    y1: 296.84,
    x2: 1598.91,
    y2: 584.44,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1840.3,
    y1: 296.84,
    x2: 1704.54,
    y2: 584.44,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1938.42,
    y1: 296.84,
    x2: 1802.66,
    y2: 584.44,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1754.22,
    y1: 560.24,
    x2: 1868.53,
    y2: 749.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a22b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0423c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1791.65,
    y1: 558.36,
    x2: 1770.15,
    y2: 631.86,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 8222.48,
    y1: 993.72,
    x2: 8069.73,
    y2: 1159.87,
    gradientTransform: "matrix(-1, 0, 0, 1, 10078.89, 0)",
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 8172.9,
    y1: 1006.06,
    x2: 8186.47,
    y2: 1006.06,
    gradientTransform: "matrix(-1, 0, 0, 1, 10078.89, 0)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 8188.21,
    y1: 962.22,
    x2: 8035.47,
    y2: 1128.37,
    gradientTransform: "matrix(-1, 0, 0, 1, 10078.89, 0)",
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 8124,
    y1: 1005.37,
    x2: 8135.72,
    y2: 1005.37,
    gradientTransform: "matrix(-1, 0, 0, 1, 10078.89, 0)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 1761.59,
    y1: 555.8,
    x2: 1875.9,
    y2: 745.29,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1911.04,
    y1: 616.76,
    x2: 1923.04,
    y2: 695.26,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1504.29,
    y1: 487.68,
    x2: 1485.79,
    y2: 533.68,
    gradientTransform: "matrix(-0.75, -0.67, -0.67, 0.75, 4382.05, -1585.24)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1491.24,
    y1: 482.44,
    x2: 1472.74,
    y2: 528.44,
    gradientTransform: "matrix(-0.75, -0.67, -0.67, 0.75, 4382.05, -1585.24)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 2007.98,
    y1: 734.75,
    x2: 1922.5,
    y2: 955.14,
    gradientTransform: "matrix(-1, 0, 0, 1, 3980.21, 0)",
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 2037.89,
    y1: 746.35,
    x2: 1952.41,
    y2: 966.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 3980.21, 0)",
    xlinkHref: "#linear-gradient-108"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.88,63.1c-30.22,16.6-84.74,55-132.3,112.36-35.39,42.65-48.05,70-80.9,76.87-24.08,5-51.2-4.09-88.41-24.4-79.6-43.45-173.12-14.26-240.79,101.45S-.68,554.65,124.25,684.47c91.42,95-31.52,96-102.6,260.68s29.17,349.34,359,347.14c330.26-2.2,829.5,2,829.51,2,260.75,2.2,542.07,42.64,784.46-71.2,87.59-41.13,165-104.57,208-186.24,56.77-107.85,37.8-243.36-37.21-340.4-50-64.69-122-46.06-182-88.64-62.63-44.44-100.3-92.68-10.75-171.77s158.09-132.38,112.82-237.17c-65-150.34-222.55-169.73-395.71-106s-382.07,158.9-536.35,117.45C995.6,167.92,980.14,53.41,787.15,33.89,744.24,29.55,660.42,21.08,583.88,63.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2214,719.67c13.2,65.43,74.44,449.33-275.48,571.51,0,0-105.38-242.36,266.19-574.62A5.65,5.65,0,0,1,2214,719.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2185.92,780.37c-3.35,22.27-7.64,44.32-12.33,66.31s-10,43.84-15.77,65.56-12.16,43.29-19.07,64.69c-1.78,5.34-3.44,10.71-5.3,16l-5.53,15.94c-3.88,10.55-7.67,21.14-11.87,31.58-4,10.52-8.49,20.85-12.86,31.22l-6.91,15.41c-2.25,5.16-4.83,10.17-7.23,15.27a652.77,652.77,0,0,1-32.27,59.39l-4.4,7.23-4.65,7.07-4.66,7.07-2.33,3.53-2.47,3.44-9.9,13.75-10.52,13.3a385,385,0,0,1-47.27,48.71,3.46,3.46,0,1,1-4.49-5.27h0l0,0a378.58,378.58,0,0,0,46.75-47.48l10.46-13,9.88-13.5,2.46-3.38,2.33-3.48,4.66-7,4.65-7,4.41-7.12a651.11,651.11,0,0,0,32.44-58.66c2.42-5,5-10,7.29-15.12l7-15.26c4.42-10.28,8.94-20.53,13-31,4.25-10.35,8.11-20.87,12.05-31.35l5.62-15.83c1.9-5.28,3.59-10.62,5.4-15.92q10.58-31.9,19.48-64.34t16.21-65.27c4.84-21.88,9.3-43.89,12.78-66v0a1.47,1.47,0,0,1,2.9.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2268.89,1038.73c-10.41,46.82-81.2,316.47-325,288,0,0,4.72-190.87,320.32-292.93C2267,1032.94,2269.57,1035.68,2268.89,1038.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2235.54,1069.89c-8,12.89-16.49,25.43-25.17,37.85s-17.65,24.62-26.86,36.65-18.69,23.85-28.43,35.46-19.74,23-30.11,34.09-21,22-32,32.34-22.39,20.56-34.31,30c-23.68,19-49.33,36-77.37,48.5a3.46,3.46,0,1,1-2.82-6.32h0l.06,0c27.4-11.84,52.83-28.21,76.43-46.79,11.88-9.21,23.2-19.14,34.28-29.33s21.74-20.86,32.15-31.76,20.5-22.12,30.32-33.57,19.39-23.13,28.71-35,18.37-24,27.16-36.24,17.39-24.71,25.48-37.4v0a1.47,1.47,0,0,1,2.48,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M17,450.82c-1,67.26,7.71,458.22,349.63,498.84,0,0,55.72-262-341.62-504C21.48,443.54,17,446.42,17,450.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56,503c6.89,20,14.57,39.75,22.54,59.37s16.42,39,25.22,58.31,18.07,38.3,27.74,57.14,19.74,37.45,30.4,55.72,21.68,36.33,33.5,53.85,24,34.78,37.21,51.24c3.2,4.2,6.59,8.24,10,12.27s6.67,8.17,10.25,12l10.55,11.77,11,11.35a432.85,432.85,0,0,0,47.33,41.47l.05,0a4.27,4.27,0,1,1-5.12,6.84l0,0c-34.15-26.11-63.61-57.55-89.72-91.22-13.19-16.77-25.33-34.29-37-52.07s-22.66-36-33.19-54.52-20.49-37.27-30-56.27S108,642,99.33,622.65s-16.92-39-24.74-58.73-15.3-39.62-22.05-59.81A1.81,1.81,0,0,1,56,502.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M471.9,16.77c-36.6,57.91-235.82,403.62,55,648.84,0,0,189.75-193.83-44.95-648.42A5.8,5.8,0,0,0,471.9,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.21,85.76C475.8,107.34,472.82,129,470,150.7s-5.3,43.4-7.57,65.15c-4.54,43.49-8.12,87.08-10.34,130.73S449,434,450.49,477.6q1,32.73,4.4,65.28a547.36,547.36,0,0,0,10.34,64.43h0a2.81,2.81,0,1,1-5.48,1.26v0a555.62,555.62,0,0,1-10.05-65.14q-3.26-32.77-4-65.67c-1.21-43.83,0-87.66,2.45-131.38s6.35-87.35,11.16-130.86q3.61-32.64,8-65.18c2.92-21.69,6-43.35,9.58-65a1.2,1.2,0,0,1,2.36.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.92,80.64C197.15,164.86,96.27,659.91,543.82,838c0,0,150.31-308.82-313.66-760.9A7.34,7.34,0,0,0,217.92,80.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254,160.69c3.27,28.94,7.76,57.78,12.8,86.48s10.84,57.29,17.31,85.71C297.1,389.71,312.76,446,332,500.94s42.24,108.72,70.74,159.46c7.08,12.7,14.64,25.12,22.51,37.34s16.18,24.15,24.94,35.72A468.39,468.39,0,0,0,508.45,798h0a2.81,2.81,0,1,1-3.8,4.15h0a474.89,474.89,0,0,1-58.61-65.51q-13.17-17.6-25-36.15c-7.87-12.34-15.42-24.89-22.49-37.7-28.44-51.19-51.18-105.3-70.32-160.49S293.75,390.58,281,333.59q-9.52-42.76-16.94-85.94c-4.92-28.78-9.28-57.65-12.43-86.72a1.19,1.19,0,1,1,2.37-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.17,1022.05v10.55c0,1.81,1.45,3.54,4,4.72l2.5,1.17c2,1,1.61,2.75-.82,3.4h0c-1.61.42-1.91,1.59-.57,2.24l3.14,1.52c2,1,2.06,2.74,0,3.74l-2.26,1.1c-1.94,1-1.89,2.61.12,3.52l2.42,1.1c1.69.76,2,2.1.64,3.05l-1.33.95a3,3,0,0,0-1.47,2.38v16.67H393.1V1021Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.17,1077.9v38.86c0,6.66,1.45,13,4,17.37l2.5,4.31c2,3.54,1.61,10.11-.82,12.48h0c-1.61,1.56-1.91,5.89-.57,8.26l3.14,5.6c2,3.67,2.06,10.09,0,13.77l-2.26,4c-1.94,3.49-1.89,9.62.12,13l2.42,4c1.69,2.8,2,7.75.64,11.23L66,1214.32a25,25,0,0,0-1.47,8.74v61.35H393.1v-210.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M405.43,1083.23H57.14a5.07,5.07,0,0,1-5.07-5.07h0a5.07,5.07,0,0,1,5.07-5.08H405.43a5.07,5.07,0,0,1,5.08,5.08h0A5.07,5.07,0,0,1,405.43,1083.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M405.43,1288.92H57.14a5.07,5.07,0,0,1-5.07-5.07h0a5.07,5.07,0,0,1,5.07-5.08H405.43a5.07,5.07,0,0,1,5.08,5.08h0A5.07,5.07,0,0,1,405.43,1288.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.17,917.6V937a11.49,11.49,0,0,0,4,8.69l2.5,2.16a3.77,3.77,0,0,1-.82,6.24h0a2.5,2.5,0,0,0-.57,4.13l3.14,2.8a4.62,4.62,0,0,1,0,6.88l-2.26,2a4.3,4.3,0,0,0,.12,6.49l2.42,2a4.08,4.08,0,0,1,.64,5.62L66,985.82a7.21,7.21,0,0,0-1.47,4.37v30.69H393.1V915.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M399.06,919.2H50.77a5.07,5.07,0,0,1-5.08-5.07h0a5.07,5.07,0,0,1,5.08-5.08H399.06a5.07,5.07,0,0,1,5.07,5.08h0A5.07,5.07,0,0,1,399.06,919.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M405.43,1027H57.14a5.07,5.07,0,0,1-5.07-5.08h0a5.07,5.07,0,0,1,5.07-5.07H405.43a5.07,5.07,0,0,1,5.08,5.07h0A5.07,5.07,0,0,1,405.43,1027Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M381.71,940.1h-312a1.23,1.23,0,1,1,0-2.46h312a1.23,1.23,0,0,1,0,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M381.71,958.4H77.08a1.23,1.23,0,1,1,0-2.46H381.71a1.23,1.23,0,1,1,0,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M381.71,971.87H80.86a1.23,1.23,0,1,1,0-2.46H381.71a1.23,1.23,0,0,1,0,2.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 948.32,
    y: 826.43,
    width: 300.58,
    height: 170.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 948.32,
    y: 1056.58,
    width: 300.58,
    height: 170.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 945.47,
    y: 563.13,
    width: 303.43,
    height: 174.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 897.04,
    y: 212.42,
    width: 445.15,
    height: 238.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.12,1122.05H686.83V1010.57H302.12C310.35,1010.57,310.35,1122.05,302.12,1122.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M686.83,1094.15v-51c0-18-7.6-32.56-17-32.56H303.74c-7.38,0-13.35-8.66-13.35-19.34,0-3.24,1.81-5.87,4.05-5.87H694.58c9.17,0,23.74,20.89,23.74,46.65v71.26c0,24.3-14.14,44-22.79,44h-399c-3.41,0-6.16-4-6.16-8.92,0-9,5-16.29,11.24-16.29H672.29C680.32,1122.05,686.83,1109.56,686.83,1094.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M676.16,1034.67H315.44a1.23,1.23,0,0,1,0-2.46H676.16a1.23,1.23,0,1,1,0,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M676.16,1051.22H315.44a1.23,1.23,0,0,1,0-2.46H676.16a1.23,1.23,0,1,1,0,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M676.16,1067.77H315.44a1.23,1.23,0,0,1,0-2.46H676.16a1.23,1.23,0,1,1,0,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M676.16,1084.32H315.44a1.23,1.23,0,0,1,0-2.46H676.16a1.23,1.23,0,1,1,0,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M676.16,1100.87H315.44a1.24,1.24,0,0,1,0-2.47H676.16a1.24,1.24,0,1,1,0,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M325.78,1147.26H725.11a20.09,20.09,0,0,1,20.09,20.09V1275a20.1,20.1,0,0,1-20.1,20.1H325.78a20.1,20.1,0,0,1-20.1-20.1V1167.36A20.09,20.09,0,0,1,325.78,1147.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 355.36,
    y: 1164.26,
    width: 51.63,
    height: 113.87,
    rx: 7.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 276.04,
    y: 866.11,
    width: 439.52,
    height: 120.56,
    rx: 20.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.05,791.62v13.62c0,2.33,1.45,4.55,4,6.08l2.49,1.51c2.05,1.25,1.62,3.55-.82,4.38h0c-1.6.54-1.9,2.06-.57,2.89l3.14,2c2.06,1.29,2.06,3.54,0,4.83L248,828.3c-2,1.22-1.89,3.37.12,4.54l2.42,1.41c1.68,1,2,2.72.64,3.94l-1.34,1.23a4.19,4.19,0,0,0-1.47,3.06V864H577V790.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M584.45,792.75H233.12a3.56,3.56,0,0,1-3.56-3.56h0a3.56,3.56,0,0,1,3.56-3.55H584.45a3.56,3.56,0,0,1,3.56,3.55h0A3.56,3.56,0,0,1,584.45,792.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M590.83,868.23H239.5a3.56,3.56,0,0,1-3.56-3.56h0a3.56,3.56,0,0,1,3.56-3.56H590.83a3.56,3.56,0,0,1,3.55,3.56h0A3.55,3.55,0,0,1,590.83,868.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M565.59,807.39h-312c-.68,0-1.23-.39-1.23-.87s.55-.86,1.23-.86h312c.68,0,1.23.39,1.23.86S566.27,807.39,565.59,807.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M565.59,820.21H261c-.68,0-1.23-.39-1.23-.87s.55-.86,1.23-.86H565.59c.68,0,1.23.39,1.23.86S566.27,820.21,565.59,820.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M565.59,829.64H264.74c-.68,0-1.23-.38-1.23-.86s.55-.86,1.23-.86H565.59c.68,0,1.23.38,1.23.86S566.27,829.64,565.59,829.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.18,675.75s28.81,66,3.94,106.83H362.35V672Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M319.54,659.75H744.67a29.87,29.87,0,0,1,29.87,29.87v64.54a31.73,31.73,0,0,1-31.73,31.73H325.51a5.24,5.24,0,0,1-4-8.59h0a5.23,5.23,0,0,0,1.21-3.43l-1.21-77.25a4.63,4.63,0,0,0-.14-1.11l-6.9-29.33A5.24,5.24,0,0,1,319.54,659.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M223,667l1.23,5.42a7.22,7.22,0,0,0,7.17,5.61l76.14-1.37a8.52,8.52,0,0,1,8.57,7.07c2.71,15.68,8.23,54,4,85.49a7.57,7.57,0,0,1-7.48,6.6H236.28a5.15,5.15,0,0,0-5.11,5.79h0a4.9,4.9,0,0,0,4.85,4.29h83.49a8.92,8.92,0,0,0,8.77-7.19c4-19.86,13-76.27-3.86-110.23a15.79,15.79,0,0,0-14.34-8.64l-82,.72A5.26,5.26,0,0,0,223,667Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 354.09,
    y: 680.62,
    width: 48.04,
    height: 92.85,
    rx: 7.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 679.43,
    cy: 725.22,
    r: 41.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1229,371.72a2,2,0,0,1-.68-.12c-144.09-50.26-385.59-25.5-619.13-1.54l-16.09,1.65a2.06,2.06,0,1,1-.42-4.1L608.75,366c116.92-12,237.82-24.39,345.12-27.24,120.51-3.19,210.71,6.29,275.78,29a2.06,2.06,0,0,1-.67,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1220.33,419.22a2.25,2.25,0,0,1-.68-.11c-144.09-50.27-385.59-25.5-619.13-1.55l-16.09,1.65a2.06,2.06,0,0,1-.42-4.1l16.08-1.65c116.93-12,237.83-24.39,345.13-27.23,120.5-3.2,210.72,6.28,275.79,29a2.06,2.06,0,0,1-.68,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1220.33,468.21a2.25,2.25,0,0,1-.68-.11c-144.09-50.27-385.58-25.5-619.13-1.55l-16.09,1.65a2.06,2.06,0,0,1-.42-4.1l16.09-1.65c116.92-12,237.83-24.39,345.13-27.23,120.5-3.2,210.71,6.28,275.78,29a2.06,2.06,0,0,1-.68,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1225.84,510.27a2.3,2.3,0,0,1-.68-.11c-144.09-50.27-385.58-25.5-619.13-1.55l-16.09,1.65a2.06,2.06,0,0,1-.41-4.1l16.08-1.65c116.92-12,237.83-24.39,345.13-27.23,120.5-3.2,210.71,6.28,275.78,29a2.06,2.06,0,0,1-.68,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1224.65,550.1a2.35,2.35,0,0,1-.68-.11c-60.39-21.07-142.16-30.64-250-29.25a2.1,2.1,0,0,1-2.09-2,2.07,2.07,0,0,1,2-2.09c108.31-1.4,190.54,8.25,251.39,29.48a2.06,2.06,0,0,1-.68,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M588.54,550.1a2.06,2.06,0,0,1-.2-4.11l16-1.63c52.37-5.38,106.54-10.93,158.77-15.56a2.06,2.06,0,0,1,.36,4.11c-52.2,4.62-106.35,10.17-158.71,15.54l-16,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1216,597.6a2,2,0,0,1-.68-.11c-58.13-20.28-135.8-29.9-237.42-29.36h0a2.06,2.06,0,0,1,0-4.12c102.1-.54,180.21,9.15,238.79,29.59a2.06,2.06,0,0,1-.67,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M579.9,597.6a2.06,2.06,0,0,1-.21-4.11l16.17-1.65c51.64-5.3,105-10.78,156.55-15.36a2.06,2.06,0,0,1,.37,4.11c-51.49,4.57-104.88,10-156.5,15.34l-16.17,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1216,646.59a2.25,2.25,0,0,1-.68-.11c-58.13-20.28-135.8-29.9-237.42-29.36h0a2.06,2.06,0,0,1,0-4.12c102.11-.52,180.21,9.15,238.79,29.59a2.06,2.06,0,0,1-.67,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M579.9,646.59a2.06,2.06,0,0,1-.21-4.11l16-1.64c50.43-5.17,102.57-10.52,152.92-15a2.06,2.06,0,0,1,.37,4.1c-50.33,4.51-102.46,9.85-152.86,15l-16.06,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1221.52,688.65a2.25,2.25,0,0,1-.68-.11c-59.13-20.63-138.57-30.23-242.92-29.32a2.06,2.06,0,0,1,0-4.12c104.81-.9,184.73,8.76,244.31,29.55a2.06,2.06,0,0,1-.67,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M585.41,688.65a2.06,2.06,0,0,1-.21-4.11l16.14-1.65c49.81-5.11,101.31-10.39,151.07-14.87a2.06,2.06,0,0,1,.37,4.11c-49.74,4.47-101.23,9.75-151,14.86l-16.14,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.46,1402.73a3,3,0,0,0,3-3v-364.6a3,3,0,0,0-6.1,0v364.6A3,3,0,0,0,1850.46,1402.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1933.12,1402.73a3.05,3.05,0,0,0,3.06-3v-364.6a3.06,3.06,0,0,0-6.11,0v364.6A3,3,0,0,0,1933.12,1402.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2136.22,1405a3,3,0,0,0,1.19-.24,3,3,0,0,0,1.61-4l-156-366.92a3.05,3.05,0,0,0-5.62,2.39l156,366.92A3,3,0,0,0,2136.22,1405Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2039.86,1405a3,3,0,0,0,1.2-.24,3,3,0,0,0,1.61-4l-156-366.92a3.05,3.05,0,0,0-5.62,2.39l156,366.92A3,3,0,0,0,2039.86,1405Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1841.43,
    y: 1029.83,
    width: 151.48,
    height: 8.6,
    rx: 2.81,
    transform: "translate(3834.34 2068.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1907.44,1094.23h96.64a3,3,0,1,0,0-6.1h-96.64a3,3,0,1,0,0,6.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1937.1,
    y: 1157.52,
    width: 96.64,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1965.8,
    y: 1226.92,
    width: 96.64,
    height: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1995.9,1302.41h96.64a3,3,0,1,0,0-6.1H1995.9a3.05,3.05,0,1,0,0,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2025,1371.81h96.63a3.06,3.06,0,0,0,0-6.11H2025a3.06,3.06,0,0,0,0,6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1538.47,958.91a2.89,2.89,0,0,1-2.32-1.17l-5.26-7.12a45.68,45.68,0,0,1-12.45-1.1l-6.43,6.09a2.86,2.86,0,0,1-3.31.46l-10.62-5.54a2.87,2.87,0,0,1-1.52-3l1.32-8.76a45.27,45.27,0,0,1-8-9.58L1481,929a2.87,2.87,0,0,1-2.67-2l-3.59-11.42a2.89,2.89,0,0,1,1-3.18l7.13-5.27a45.22,45.22,0,0,1,1.1-12.44l-6.09-6.43a2.88,2.88,0,0,1-.46-3.32l5.53-10.62a2.9,2.9,0,0,1,3-1.51l8.76,1.31a45.42,45.42,0,0,1,9.58-8l.25-8.86a2.87,2.87,0,0,1,2-2.67l11.43-3.59a2.87,2.87,0,0,1,3.18,1l5.26,7.13a45.64,45.64,0,0,1,12.45,1.09l6.43-6.09a2.88,2.88,0,0,1,3.31-.46l10.62,5.54a2.89,2.89,0,0,1,1.52,3l-1.32,8.76a45.52,45.52,0,0,1,8,9.58l8.86.24a2.9,2.9,0,0,1,2.67,2l3.59,11.42a2.87,2.87,0,0,1-1,3.18l-7.12,5.27a45.29,45.29,0,0,1-1.1,12.45l6.09,6.43a2.86,2.86,0,0,1,.46,3.31l-5.53,10.62a2.88,2.88,0,0,1-3,1.51l-8.76-1.31a45.52,45.52,0,0,1-9.58,8l-.25,8.86a2.87,2.87,0,0,1-2,2.67l-11.43,3.59A2.8,2.8,0,0,1,1538.47,958.91Zm-5.61-12.56,6.08,8.23,9.74-3.06.28-10.23,1-.58a41,41,0,0,0,10.29-8.62l.75-.86,10.11,1.52,4.72-9-7-7.43.28-1.1a41.25,41.25,0,0,0,1.18-13.38l-.08-1.13,8.23-6.08-3.06-9.74-10.24-.28-.58-1a41.39,41.39,0,0,0-8.61-10.3l-.86-.74,1.51-10.12-9-4.72-7.43,7-1.1-.29a41.47,41.47,0,0,0-13.37-1.17l-1.14.08-6.08-8.23-9.74,3.06-.28,10.24-1,.57a41.6,41.6,0,0,0-10.29,8.62l-.74.86L1486.23,877l-4.72,9,7,7.43-.28,1.1a41.19,41.19,0,0,0-1.18,13.37l.09,1.13-8.24,6.09,3.07,9.74,10.23.28.58,1a41.35,41.35,0,0,0,8.61,10.29l.87.74-1.52,10.12,9,4.72,7.43-7,1.1.28a41.47,41.47,0,0,0,13.37,1.18Zm46.24-52.3h0Zm-22.42-32.5Zm-27.82,74.2A30.9,30.9,0,0,1,1502.53,921a2.06,2.06,0,1,1,3.51-2.15,26.84,26.84,0,1,0-.93-26.46,27.22,27.22,0,0,0-2.09,5.32,2.06,2.06,0,1,1-4-1.09,31.32,31.32,0,0,1,2.41-6.14,31,31,0,1,1,27.4,45.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1528.65,917.55a12.69,12.69,0,1,1,9.49-4.25A12.64,12.64,0,0,1,1528.65,917.55Zm0-21.27-.5,0a8.49,8.49,0,0,0-5.91,2.85h0a8.57,8.57,0,1,0,6.41-2.87Zm-8,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1600.45,875.45a1.9,1.9,0,0,1-1.54-.76l-2.4-3.17a22,22,0,0,1-5.55-.43l-2.85,2.76a1.93,1.93,0,0,1-2.23.33l-5.14-2.6a2,2,0,0,1-1-2l.55-3.93a22.19,22.19,0,0,1-3.62-4.23l-4-.06a2,2,0,0,1-1.81-1.34l-1.79-5.48a2,2,0,0,1,.68-2.15l3.16-2.39a22.42,22.42,0,0,1,.43-5.55l-2.76-2.85a1.94,1.94,0,0,1-.33-2.23l2.61-5.13a1.93,1.93,0,0,1,2-1l3.93.55a22.19,22.19,0,0,1,4.23-3.62l.07-4a1.94,1.94,0,0,1,1.33-1.81l5.48-1.79a2,2,0,0,1,2.15.67l2.39,3.17a22.42,22.42,0,0,1,5.55.43l2.85-2.76a1.94,1.94,0,0,1,2.23-.33l5.14,2.6a2,2,0,0,1,1,2l-.55,3.93a21.84,21.84,0,0,1,3.62,4.23l4,.06a2,2,0,0,1,1.81,1.34l1.79,5.48a1.93,1.93,0,0,1-.67,2.15l-3.17,2.39a22,22,0,0,1-.43,5.55l2.76,2.85a1.94,1.94,0,0,1,.34,2.23l-2.61,5.14a2,2,0,0,1-2,1l-3.93-.55a22.19,22.19,0,0,1-4.23,3.62l-.06,4a1.93,1.93,0,0,1-1.34,1.81l-5.48,1.79A2,2,0,0,1,1600.45,875.45Zm-2.49-7.14,2.92,3.86,3.91-1.28.08-4.83.73-.45a19.23,19.23,0,0,0,4.77-4.08l.55-.65,4.78.67,1.87-3.68-3.36-3.47.2-.83a19.36,19.36,0,0,0,.49-6.26l-.08-.85,3.86-2.91-1.28-3.92-4.83-.08-.44-.73a19.27,19.27,0,0,0-4.09-4.77l-.65-.55.67-4.78-3.68-1.87-3.47,3.36-.83-.2a19.36,19.36,0,0,0-6.26-.48l-.84.07-2.92-3.86-3.92,1.28-.08,4.84-.73.44a19.44,19.44,0,0,0-4.77,4.08l-.55.65-4.78-.66-1.87,3.67,3.36,3.47-.2.83a19.36,19.36,0,0,0-.48,6.26l.07.85-3.86,2.91,1.28,3.92,4.84.08.44.73a19.44,19.44,0,0,0,4.08,4.77l.65.55-.66,4.78,3.67,1.87,3.47-3.36.83.2a19.66,19.66,0,0,0,6.26.49Zm-12,3.32Zm1.32-.2Zm-5.13-2.61Zm36-10.36Zm-45.35-19Zm30.86-13h0Zm1.32-.2Zm-18.81-.08Zm5.75,37.63a1.74,1.74,0,0,1-.39-.05,15.78,15.78,0,0,1-3.08-1.18,15.44,15.44,0,1,1,15.22-.69,1.55,1.55,0,0,1-1.64-2.62,12.35,12.35,0,0,0-1-21.47,12.35,12.35,0,1,0-8.73,23,1.55,1.55,0,0,1-.39,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1464.61,1424.35a9.29,9.29,0,0,1-2.81-.42c-3.62-1.11-5.29-4.11-3.74-6.7l149.54-248.62c1.56-2.59,5.75-3.78,9.37-2.67s5.29,4.11,3.73,6.7l-149.54,248.62C1470,1423.19,1467.37,1424.35,1464.61,1424.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M536.54,1426.83a9.67,9.67,0,0,1-2.81-.42c-3.62-1.13-5.29-4.15-3.74-6.77l149.55-251c1.55-2.61,5.74-3.82,9.36-2.69s5.29,4.15,3.74,6.76l-149.55,251C541.93,1425.66,539.3,1426.83,536.54,1426.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M705,1426.83c-2.77,0-5.4-1.17-6.56-3.12l-149.54-251c-1.55-2.61.12-5.64,3.73-6.76s7.81.08,9.37,2.69l149.54,251c1.56,2.62-.11,5.64-3.73,6.77A9.67,9.67,0,0,1,705,1426.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1340.71,
    y: 1279.35,
    width: 11.77,
    height: 127.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1398.13,1409.07H1295.05v-.55a7.11,7.11,0,0,1,7.11-7.11h88.31a7.66,7.66,0,0,1,7.66,7.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1283.83,
    y: 1250.83,
    width: 129.59,
    height: 36.75,
    rx: 12.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1259.71,1194.49s-17.49,2.71-37.15,15.86a9.78,9.78,0,0,0-4.32,9.36c2.35,18.65,12,79,44,138a14.89,14.89,0,0,1,1.43,10.19l-5.55,25.81-10.28,9.64h26.48l17.64-47.73-7.54-2.39a14.27,14.27,0,0,1-10-13.36l-.88-51.2c.75-22.81-14-38.55-14-38.55l42.31-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1237.44,1408c-2.41,3.16,26,7.33,40.3.42,0,0,19.88-34.58,19.88-52.38,0,0-1.58-3.63-13.25-2.81,0,0-6.67,41-13.72,45.53s-19.71.47-19.71.47S1241,1403.31,1237.44,1408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1296.49,1250.83c-.23-.39-45.55-5.45-45.55-5.45s1.48,13.78-3.15,32.75-71.18,101.16-71.18,101.16l7,22.12c-21.57,7.52-42.79,8.72-63.67,3.83l43.24-26s40.47-137.91,65.26-162.51l45.43-15.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1398.13,1170.59s26.11,38.84,28.25,56.56-7.15,24.91-34.55,26.1-100.54,1.17-100.54,1.17l-62.43-53.36s45.5-16.23,57.32-20.82S1398.13,1170.59,1398.13,1170.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1181,1394s7.51,7.28,2.44,15.37c0,0-59.51,10.55-75.67,5.76,0,0,3.36-7.65,21.55-16.37l-1.34,1a2.17,2.17,0,0,0,1.43,3.9C1141.35,1403,1166.16,1400.77,1181,1394Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 841.68,
    y: 1246.68,
    width: 14.49,
    height: 156.71,
    transform: "translate(1697.86 2650.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M785.47,1397H912.39a0,0,0,0,1,0,0v6.36a3.08,3.08,0,0,1-3.08,3.08h-121a2.86,2.86,0,0,1-2.86-2.86V1397A0,0,0,0,1,785.47,1397Z",
    transform: "translate(1697.86 2803.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 761.47,
    y: 1209.36,
    width: 169.59,
    height: 48.1,
    rx: 16.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 512.64,
    y: 1285.13,
    width: 10.48,
    height: 113.3,
    transform: "translate(1035.75 2683.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M472,1400.61h91.77a6.83,6.83,0,0,0-6.82-6.82H478.81a6.83,6.83,0,0,0-6.82,6.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 458.37,
    y: 1259.74,
    width: 115.37,
    height: 32.72,
    rx: 11.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M595.22,1209.58s15.57,2.41,33.07,14.12a8.7,8.7,0,0,1,3.85,8.33c-2.09,16.61-10.71,70.34-39.13,122.83a13.19,13.19,0,0,0-1.27,9.06l4.94,23,9.16,8.58H582.25L566.55,1353l6.72-2.12a12.73,12.73,0,0,0,8.87-11.9l.79-45.58c-.68-20.31,12.45-34.32,12.45-34.32l-37.66-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M615,1399.63c2.15,2.81-23.11,6.52-35.87.37,0,0-17.7-30.78-17.7-46.63,0,0,1.41-3.24,11.8-2.5,0,0,5.94,36.45,12.21,40.53s17.55.41,17.55.41S611.88,1395.48,615,1399.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M562.48,1259.74c.2-.35,40.55-4.85,40.55-4.85s-1.32,12.27,2.81,29.16,63.36,90,63.36,90L663,1393.79c19.21,6.69,38.1,7.76,56.69,3.41l-38.5-23.1s-36-122.77-58.09-144.67l-40.45-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M665.34,1387.16s-6.69,6.48-2.17,13.68c0,0,53,9.39,67.36,5.13,0,0-3-6.81-19.18-14.57l1.19.92a1.93,1.93,0,0,1-1.28,3.47C700.59,1395.18,678.5,1393.22,665.34,1387.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M571.65,1196.89c-3.08-1.19-12.89-2.42-25.22-3.57h0c13.07-18.8,20.77-40.71,24.76-64.79L509,1127.17c-5.83,21.46-38.48,63.37-40.75,67,0,0-20,32.75-21.38,44.51-1.91,15.77,6.37,22.18,30.76,23.24s89.51,1,89.51,1l55.57-47.5S582.18,1201,571.65,1196.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M905,1377.55s40.11,28.92,33.14,48.34c0,0-43.88-18.94-49.19-33.85s.9-21.5.9-21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M899,1353.33l-6.56,19A6.58,6.58,0,0,0,895,1380a17.1,17.1,0,0,0,5.43,2.1,7.67,7.67,0,0,0,8.49-3.85l7.84-14.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M835.12,1182.67s82.39,14.27,117.73,46.92-32.44,136.78-32.44,136.78-11.1-.06-24.56-11.6c0,0,40.19-78.32,5.55-101.16-38.93-25.68-83.81-31.46-83.81-31.46l16.74-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M931.15,1415.15c-8.82-4.09-33.8-21.57-38-22.34s-11.51,4.18-11.51,4.18-1.77,3.19.13,8.76c5.86,7.1,18.87,20.62,36.37,25.66,12.87,3.7,21.88.25,27.48-3.79A37.1,37.1,0,0,0,931.15,1415.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M918.13,1431.41c-17.5-5-30.51-18.56-36.37-25.66,1.28,3.77,4.24,8.62,10.57,14.3,15.68,14.1,45.65,19.19,52,18.21,5.11-.79,4.63-5.51,1.25-10.64C940,1431.66,931,1435.11,918.13,1431.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M874.15,1384.65c.1,2.43,5.07,10.76,8,15.44a7.59,7.59,0,0,0,6.41,3.59,19.55,19.55,0,0,0,5.3-.64,4.91,4.91,0,0,0,3.3-6.11l-5.67-19.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M755.82,1157.94s-18.3,48.92,0,63.8,61.94,31.62,71.69,61.26,26.3,87.22,48.44,107.62c0,0,15.56-1.51,21.38-7.71,0,0-12.61-86-20.93-108-7.2-19.11-17.81-46.68-38.15-62.09-5.82-4.41-4.81-11.4-2.11-18.19l4.92-12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M946.64,1119.59c-30.68,1.85-21.12-47.16-20.57-49.11l-46.56,32.89s2.47,26.21,41.18,40a48.1,48.1,0,0,0,26.66,1.93A42.32,42.32,0,0,1,946.64,1119.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1006,1104.84c-11.43-7.95-24.39,0-24.39,0-15.28,10-26.59,14.25-34.93,14.75a42.32,42.32,0,0,0,.71,25.67c17.12-3.68,29.37-16.07,34.7-22.43a5.52,5.52,0,0,1,7.65-.84c2.38,1.88,4.69,4.45,4.27,7.16-.82,5.34,5.38,7,5.84,5.1s-2.12-13.42-2.12-13.42,12.4,12.47,17.24,17.26,10.93,0,10.93,0S1017.39,1112.79,1006,1104.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M795.59,996.79s44.64-17.87,127.69,50.71c0,0,6.94,14.36-.63,27.14s-79.68,75.06-89.59,109.6c0,0-43,14-87.39-19.14C745.67,1165.1,749.59,1069,795.59,996.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M891.82,978.85l-22,26.63a8.74,8.74,0,0,0-1.15,9.4c3,6.22,10.29,15.28,26.33,14a13.51,13.51,0,0,0,11.09-7.57l15.36-31.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M769,1108.87c-5.18-21.11,47.3-68.15,47.3-68.15l-12.75-45.93s-113.32,75.44-84.44,136.11c4.14,8.7,9.64,14.79,16,18.86C744.29,1125.2,758.83,1113.93,769,1108.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M769,1105.79a1.24,1.24,0,0,1-1.2-.94c-5.3-21.57,45.51-67.42,47.68-69.36a1.24,1.24,0,0,1,1.75.09,1.25,1.25,0,0,1-.1,1.76c-.52.46-51.87,46.78-46.92,66.92a1.25,1.25,0,0,1-.91,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M848.53,1107.05s-62.22,24.16-77.41,6a10.31,10.31,0,0,1-2.08-4.17c-10.21,5.06-24.75,16.33-33.87,40.89,32.72,20.91,88.66-11.63,103.78-21.23a11.33,11.33,0,0,1,8.36-1.53c5.83,1.21,15.91,3,21.34,2.15,8-1.22,19.38,26.82,32.26,18.17C900.91,1147.32,889.88,1098.57,848.53,1107.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M946.63,948.2s.38,29-4.3,42.17-5.42,22.69-21.39,19-25.4-16.33-26.81-32c0,0-2.34-24.22,3.44-31.31S946.63,948.2,946.63,948.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M903.09,970.32l1.88.78S903.89,952,911.88,952s37.27,5.89,47.11-1.24c9.49-6.87,9.49-20.9,3.4-27.38a1.08,1.08,0,0,0-1.47-.06l-1.12.91a1.09,1.09,0,0,1-1.78-1h0a1.09,1.09,0,0,0-1.7-1c-3,2.12-9.76,4.75-23.7,1.7-19.79-4.32-35-2-40.67,10.58a1.1,1.1,0,0,1-1.92.17c-1-1.39-3-2.69-6.93-1.47-6.82,2.12-9.38,14-2.12,27.67a1.09,1.09,0,0,1-.73,1.6c-2.55.47-6.84,2.32-.84,9.7,6.14,7.56,11,9.06,13,9.35a1.09,1.09,0,0,0,1.2-.72l4-11.54a1.1,1.1,0,0,1,1.46-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M902.56,972.86s2.51-17.37-6.36-15.93-3.72,19.08,1.68,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1633.07,1424.35c-2.76,0-5.39-1.16-6.55-3.09L1477,1172.64c-1.56-2.59.11-5.59,3.73-6.7s7.81.08,9.37,2.67l149.54,248.62c1.56,2.59-.12,5.59-3.73,6.7A9.4,9.4,0,0,1,1633.07,1424.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1648,1159.31a5.91,5.91,0,0,0-2.31-6.22,13.38,13.38,0,0,0-8.46-2.74H527.51c-4.31,0-8.32,1.5-10.64,4a6.42,6.42,0,0,0-.83,8.31l12,17.86c2.75,4.09,8.72,6.71,15.29,6.71H1629.61c6.11,0,11.36-3,12.52-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M884.64,1090.46l10.65,46.12v30.82l-177.5-3a4.37,4.37,0,0,1-4.29-4.37v-2a4.35,4.35,0,0,1,2.35-3.87l109.06-56.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M742.28,1133.27l-22,21.46a1,1,0,0,0,.75,1.69c15.89-.91,100.59-4.91,174.22,8.77v-70.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M720.48,1150.68c19.79-1.49,130.57-8.65,174.81,14.51v-70.35s-124.87,5.31-171,28c0,0,4.27,15.9-4.73,26A1.1,1.1,0,0,0,720.48,1150.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M725.17,1128.29l-3.83,3.71a.68.68,0,0,0,.5,1.16c13.32-.72,97.42-3.65,173.45,32C895.29,1165.19,833.4,1121.86,725.17,1128.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M895.29,1089.22s-47.22-34.57-101.45-9.56l-71.06,42.47a.5.5,0,0,0,.36.92c17.23-3.73,102.65-18.27,172.15,41.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M895.29,1090.46s-46.29-35.23-100.53-10.21L729,1119.7a.5.5,0,0,0,.36.92c17.24-3.73,96.39-19.88,165.89,39.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M756,1108.26l47.2-27.79a6,6,0,0,1,1.76-.7c6.69-1.49,46.61-9.15,78.53,13a4.51,4.51,0,0,1,1.85,4.68l-7.42,33.8a2.23,2.23,0,0,1-3.49,1.32c-10.72-7.93-52.51-34.51-118.08-23.33A.51.51,0,0,1,756,1108.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M875.74,1134.08a3.3,3.3,0,0,1-2-.66c-11.11-8.21-52.41-34.17-117.23-23.12a1.63,1.63,0,0,1-1.1-3l47.2-27.79a7.4,7.4,0,0,1,2.09-.82c7.63-1.7,47.33-9.09,79.41,13.14a5.61,5.61,0,0,1,2.3,5.83l-7.42,33.8a3.31,3.31,0,0,1-2.09,2.42A3.4,3.4,0,0,1,875.74,1134.08Zm-88.09-28.7c47.61,0,78.06,19.32,87.43,26.25a1.1,1.1,0,0,0,1.74-.66l7.42-33.79a3.39,3.39,0,0,0-1.39-3.53c-31.32-21.69-70.18-14.46-77.65-12.79a4.93,4.93,0,0,0-1.45.57l-44.43,26.16A185.14,185.14,0,0,1,787.65,1105.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M728.68,1135a394.49,394.49,0,0,1,41,0c13.63.65,27.23,1.91,40.74,3.9a323.59,323.59,0,0,1,40.05,8.35c6.59,1.8,13.07,4,19.49,6.27s12.69,5.07,18.85,8a.66.66,0,0,1,.31.87.65.65,0,0,1-.86.31h0c-6.16-2.84-12.42-5.46-18.81-7.73s-12.86-4.31-19.43-6a322,322,0,0,0-39.9-7.87c-13.45-1.83-27-2.93-40.55-3.43a393.13,393.13,0,0,0-40.63.47h0a1.54,1.54,0,1,1-.21-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M729.51,1125.09c6.88-.8,13.68-1.12,20.52-1.25s13.67,0,20.49.4a282.92,282.92,0,0,1,40.6,5.25A241.33,241.33,0,0,1,850.37,1141l2.39.92,2.36,1,4.7,2c3.08,1.47,6.22,2.82,9.24,4.43,6.12,3,12,6.53,17.77,10.12a.52.52,0,1,1-.54.88h0c-5.8-3.51-11.66-6.95-17.78-9.88-3-1.57-6.15-2.87-9.22-4.3l-4.7-1.94-2.35-1-2.38-.89a240.15,240.15,0,0,0-39.1-11,279.23,279.23,0,0,0-40.35-4.78q-10.14-.46-20.31-.19c-6.75.2-13.56.6-20.19,1.45h0a1.38,1.38,0,0,1-.35-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M727.73,1146c13.4-.56,26.75-.57,40.12-.27s26.72,1,40,2.14,26.59,2.83,39.79,5a339.54,339.54,0,0,1,39,9.16.53.53,0,0,1,.34.65.51.51,0,0,1-.64.34h0a336.71,336.71,0,0,0-39-8.67q-19.75-3-39.69-4.51t-39.93-1.66c-13.31-.14-26.66,0-39.92.74h0a1.46,1.46,0,1,1-.15-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M826.24,1107.3l-.31-.18a98.38,98.38,0,0,0-14.71-7.24l-1.26-.5,36-13.1a.52.52,0,0,1,.35,1l-33.42,12.17a99.9,99.9,0,0,1,13.3,6.63c7.77-6.25,15.43-12.84,22.79-19.6-13.93-1.48-29.56-3-44.75-.6l4.19,9.45a.52.52,0,0,1-1,.42l-4.72-10.67.65-.11c15.95-2.69,32.35-.94,46.82.61l1.12.12-.83.77c-7.71,7.12-15.77,14.07-24,20.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M808.15,1095.35a.51.51,0,0,1-.5-.37.53.53,0,0,1,.36-.64c8-2.26,16.22-3.83,24.2-5.34l11.84-2.25a.51.51,0,1,1,.19,1L832.4,1090c-8,1.51-16.19,3.08-24.11,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M812.17,1105.48l-5.06-8.78a.52.52,0,1,1,.89-.52l4.17,7.25a9,9,0,0,1,2.13-2.18.52.52,0,1,1,.61.83,7.86,7.86,0,0,0-2.3,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M838.71,1109l13.43-19.78a.51.51,0,0,1,.66-.17.48.48,0,0,1,.31-.08.5.5,0,0,1,.49.54l-.75,15-.31.12a111,111,0,0,1-12.51,4Zm13.81-18.51-11.42,16.82a109.66,109.66,0,0,0,10.75-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M858,1102.8l-.19-.4a116.14,116.14,0,0,1-4.84-12.32.57.57,0,0,1,0-.26.51.51,0,0,1,.58-.83,66.23,66.23,0,0,1,13.69,8.82,1.5,1.5,0,0,1,.67,1.26c-.09.78-.94,1-1.22,1.12Zm-3.82-12.34a113.68,113.68,0,0,0,4.38,11.1l7.82-2.36c.46-.14.5-.25.5-.25s0-.09-.31-.35A64.48,64.48,0,0,0,854.16,1090.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M856.14,1108.69a.71.71,0,0,1-.59-.33l-3.07-4a.52.52,0,0,1,.1-.73.51.51,0,0,1,.72.1l2.69,3.5,1.61-5a.51.51,0,1,1,1,.31l-1.8,5.66a.72.72,0,0,1-.41.48A.63.63,0,0,1,856.14,1108.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M855.75,1107a.53.53,0,0,1-.51-.43l-2-12a.53.53,0,0,1,.43-.6.52.52,0,0,1,.59.43l2,12.05a.5.5,0,0,1-.42.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M905.42,1090.46l-10.65,46.12v30.82l177.49-3a4.37,4.37,0,0,0,4.3-4.37v-2a4.37,4.37,0,0,0-2.35-3.87L965.14,1097.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1047.78,1133.27l22,21.46a1,1,0,0,1-.74,1.69c-15.9-.91-100.59-4.91-174.22,8.77v-70.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1069.58,1150.68c-19.8-1.49-130.58-8.65-174.81,14.51v-70.35s124.86,5.31,171,28c0,0-4.26,15.9,4.74,26A1.1,1.1,0,0,1,1069.58,1150.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1064.89,1128.29l3.83,3.71a.68.68,0,0,1-.5,1.16c-13.32-.72-97.43-3.65-173.45,32C894.77,1165.19,956.65,1121.86,1064.89,1128.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M894.77,1089.22s47.21-34.57,101.45-9.56l71.06,42.47a.5.5,0,0,1-.36.92c-17.24-3.73-102.66-18.27-172.15,41.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M894.77,1090.46s46.29-35.23,100.52-10.21L1061,1119.7a.5.5,0,0,1-.36.92c-17.23-3.73-96.39-19.88-165.88,39.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1034.07,1108.26l-47.2-27.79a5.9,5.9,0,0,0-1.77-.7c-6.69-1.49-46.61-9.15-78.53,13a4.54,4.54,0,0,0-1.85,4.68l7.42,33.8a2.23,2.23,0,0,0,3.5,1.32c10.72-7.93,52.5-34.51,118.08-23.33A.51.51,0,0,0,1034.07,1108.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M913.14,1133.87a3.35,3.35,0,0,1-2.09-2.42l-7.42-33.8a5.62,5.62,0,0,1,2.31-5.83c32.08-22.23,71.78-14.84,79.41-13.14a7.22,7.22,0,0,1,2.08.82l47.2,27.79a1.63,1.63,0,0,1,.71,2,1.61,1.61,0,0,1-1.81,1c-64.81-11-106.11,14.91-117.23,23.12a3.27,3.27,0,0,1-2,.66A3.46,3.46,0,0,1,913.14,1133.87Zm117.59-26.28-44.43-26.16a4.87,4.87,0,0,0-1.44-.57c-7.47-1.67-46.34-8.9-77.65,12.79a3.42,3.42,0,0,0-1.4,3.53l7.42,33.79a1.13,1.13,0,0,0,.7.81,1.1,1.1,0,0,0,1.05-.15c9.36-6.93,39.82-26.25,87.42-26.25A185,185,0,0,1,1030.73,1107.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1061.14,1138.12a393.1,393.1,0,0,0-40.63-.47c-13.56.5-27.1,1.6-40.54,3.43a322.12,322.12,0,0,0-39.91,7.87c-6.56,1.71-13,3.79-19.43,6s-12.65,4.89-18.8,7.73h0a.65.65,0,0,1-.55-1.18c6.16-2.93,12.44-5.63,18.84-8s12.91-4.47,19.49-6.27a323.74,323.74,0,0,1,40.06-8.35c13.5-2,27.11-3.25,40.74-3.9a394.5,394.5,0,0,1,41,0,1.54,1.54,0,0,1-.18,3.08h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1060.16,1127.83c-6.63-.85-13.44-1.25-20.19-1.45s-13.55-.12-20.32.19a279.1,279.1,0,0,0-40.34,4.78,239.87,239.87,0,0,0-39.1,11l-2.38.89-2.35,1-4.7,1.94c-3.08,1.43-6.21,2.73-9.22,4.3-6.13,2.93-12,6.37-17.78,9.88h0a.51.51,0,0,1-.7-.17.52.52,0,0,1,.16-.71c5.8-3.59,11.65-7.11,17.78-10.12,3-1.61,6.15-3,9.23-4.43l4.71-2,2.36-1,2.38-.92a241.33,241.33,0,0,1,39.25-11.54,282.92,282.92,0,0,1,40.6-5.25q10.23-.57,20.49-.4c6.85.13,13.65.45,20.52,1.25a1.38,1.38,0,0,1-.32,2.74h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1062.16,1148.87c-13.25-.71-26.6-.88-39.92-.74s-26.63.72-39.92,1.66-26.53,2.51-39.7,4.51a336.71,336.71,0,0,0-39,8.67h0a.52.52,0,1,1-.29-1,338.56,338.56,0,0,1,39-9.16q19.79-3.24,39.78-5t40-2.14c13.37-.3,26.73-.29,40.13.27a1.46,1.46,0,0,1-.12,2.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M963.82,1107.3l-.28-.22c-8.18-6.57-16.24-13.52-23.95-20.64l-.84-.77,1.13-.12c14.47-1.55,30.86-3.3,46.81-.61l.65.11-4.72,10.67a.51.51,0,1,1-.94-.42l4.18-9.45c-15.19-2.45-30.82-.88-44.74.6,7.35,6.76,15,13.35,22.78,19.6a100.51,100.51,0,0,1,13.3-6.63l-33.42-12.17a.53.53,0,0,1-.31-.66.52.52,0,0,1,.67-.31l36,13.1-1.27.5a99.34,99.34,0,0,0-14.71,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M981.91,1095.35h-.14c-7.93-2.25-16.16-3.82-24.12-5.33l-11.84-2.25a.51.51,0,0,1-.41-.6.51.51,0,0,1,.6-.41l11.85,2.25c8,1.51,16.23,3.08,24.2,5.34a.52.52,0,0,1,.35.64A.5.5,0,0,1,981.91,1095.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M977.89,1105.48l-.44-.8a8,8,0,0,0-2.3-2.6.52.52,0,0,1-.12-.72.51.51,0,0,1,.72-.11,8.82,8.82,0,0,1,2.13,2.18l4.17-7.25a.52.52,0,0,1,.71-.19.53.53,0,0,1,.19.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M951.34,1109l-1.32-.34a110.21,110.21,0,0,1-12.5-4l-.31-.12-.76-15a.52.52,0,0,1,.49-.54.43.43,0,0,1,.31.08.52.52,0,0,1,.67.17Zm-13.14-5.2a110.54,110.54,0,0,0,10.75,3.51l-11.42-16.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M932.08,1102.8l-8.69-2.61c-.28-.09-1.12-.34-1.21-1.12a1.46,1.46,0,0,1,.67-1.26,65.7,65.7,0,0,1,13.69-8.82.51.51,0,0,1,.69.24.54.54,0,0,1-.11.59.58.58,0,0,1,0,.26,116.08,116.08,0,0,1-4.83,12.32Zm3.81-12.34a64.72,64.72,0,0,0-12.38,8.14c-.32.26-.31.34-.31.35s0,.11.49.25l7.83,2.36A116.19,116.19,0,0,0,935.89,1090.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M933.92,1108.69a.55.55,0,0,1-.23,0,.65.65,0,0,1-.41-.48l-1.8-5.66a.52.52,0,0,1,.33-.65.53.53,0,0,1,.65.34l1.6,5,2.7-3.5a.51.51,0,1,1,.81.63l-3.06,4A.74.74,0,0,1,933.92,1108.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M934.3,1107h-.08a.5.5,0,0,1-.42-.59l2-12.05a.53.53,0,0,1,.6-.43.52.52,0,0,1,.42.6l-2,12A.52.52,0,0,1,934.3,1107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1341.41,1156.63h-.3l-129.59-.14a5.8,5.8,0,1,1,0-11.6l129.6.14a5.8,5.8,0,0,1,.28,11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1095,1039h107.93a20.57,20.57,0,0,1,18.61,11.79l49.89,105.8H1137.32a12.51,12.51,0,0,1-11.63-7.9L1087,1050.75A8.61,8.61,0,0,1,1095,1039Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1171.05,1093.21c2.34,7.27.61,14.33-3.86,15.77s-10-3.29-12.33-10.56-.61-14.32,3.86-15.76S1168.71,1086,1171.05,1093.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1344.11,931.29c4,1.23,18.17,6.33,16.34,15.48a1.67,1.67,0,0,0,2.09,1.92c6.13-1.65,19.67-3.73,28.06,6.78,7.41,9.29,1.87,18-2.64,22.86a1.68,1.68,0,0,0,1.4,2.85c11.27-1.43,35.75-1.77,39.76,21.17,3.73,21.38-11.15,27.41-20,29.11a1.68,1.68,0,0,0-.56,3.07c4.4,2.79,9.51,8.57,7.45,20-3.24,17.86-38.25,16.4-42.34,16.17a1.68,1.68,0,0,1-.73-.22l-56.08-32a1.7,1.7,0,0,1-.83-1.17l-11.32-65.39a1.7,1.7,0,0,1,.44-1.46l37.24-38.7A1.66,1.66,0,0,1,1344.11,931.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1326.27,1144.33s-30.41-28.95-45.38-48.13a40.7,40.7,0,0,1-6.89-36.62c6.83-23,19-46.87,20.09-50.58,1.69-5.69,35.79-5.45,35.79-5.45s67.09,43.54,93.45,117.3l-29.6,9.22s-17.52-29.39-34.83-48.08c0,0,29.95,39.57,31,55.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1290,977.21c.36,1.18,9.26,30.68,10,31.29s19.52,1.63,28.38-4.43l-15-31.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1304.58,915.24s-16.06,6.78-27,30-2.76,33.93,7.48,35.41,25.57,1.24,41.78-13.75S1325.47,907.2,1304.58,915.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1316,954.5s12.12-34-18-34.36l-7.08,5s-11.05-18.83,7.08-27.82,39.36-1.57,47.08,22.87,9,40.78-3.8,52.47-18.13-1.56-18.13-1.56,7-10.94,4.14-16.79-9.41,1.21-9.41,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1316.6,959s6.13-17.5,14.3-10.53-6.64,16.16-12.45,19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1264.32,1146.48l22.34-21.53,30.91,13s30.76,4.77,48.37,0l17.6-4.76,39.79-12.39,6.25,17.66a10.65,10.65,0,0,1-3.88,12.22,71.78,71.78,0,0,1-10,6.26c-5.24,2.29-129.17-1.59-129.17-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M559.21,1140.22,659.67,1139a13.92,13.92,0,0,1,8.88,3.11l35.65,28.5c2.8,2.24,1.4,7.1-2.07,7.16L592,1179.44a10.15,10.15,0,0,1-7.25-3l-28.48-27.65C553.22,1145.85,555.11,1140.27,559.21,1140.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M561.83,1140.09l94.45-1.17a13.11,13.11,0,0,1,8.35,2.93l33.52,26.79c2.63,2.1,1.31,6.68-1.95,6.73L592.69,1177a9.57,9.57,0,0,1-6.83-2.78l-26.76-26C556.21,1145.38,558,1140.14,561.83,1140.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M608.22,973.78c0,3.22-29,122.51-29,122.51l-82.67,24.31a37.14,37.14,0,0,1-41.91-15.84h0a74.71,74.71,0,0,1,23.47-103.07l11.71-7.36a219.84,219.84,0,0,0,63.36-60.43l4.41-6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M467.41,1089a.35.35,0,0,1-.14,0c-10-6-11-19.64-10.95-25.2a64.73,64.73,0,0,1,8.41-31.27c9.69-17.07,26.39-28.64,42.54-39.82l3.34-2.32c16.38-11.39,34.47-25.23,41.81-45.2a.26.26,0,1,1,.48.18c-7.39,20.11-25.55,34-42,45.45l-3.33,2.31c-16.11,11.15-32.76,22.69-42.39,39.66a64.11,64.11,0,0,0-8.34,31c0,5.48.89,18.86,10.7,24.76a.26.26,0,0,1,.09.35A.26.26,0,0,1,467.41,1089Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M474.11,1071.21a.26.26,0,0,1-.25-.21c-2.19-11.16-1.86-21.14,1-29.66,5.15-15.39,18.77-26.56,30.06-34.57,2.26-1.6,4.59-3.21,6.84-4.76,10.37-7.13,21.09-14.51,28.85-24.54a.26.26,0,0,1,.36,0,.27.27,0,0,1,0,.36c-7.81,10.09-18.57,17.49-29,24.65-2.25,1.54-4.58,3.15-6.83,4.75-11.23,8-24.77,19.06-29.87,34.32-2.82,8.43-3.14,18.32-1,29.39a.26.26,0,0,1-.21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M565.62,1133s27.07-25.78,40.4-42.85a36.24,36.24,0,0,0,6.13-32.6c-6.08-20.5-16.89-41.73-17.88-45-1.51-5.07-31.86-4.86-31.86-4.86s-59.73,38.77-83.2,104.43l26.36,8.21s15.59-26.17,31-42.8c0,0-26.66,35.22-27.6,49.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M602.43,977.29c-.32,1.05-12.73,34.27-13.35,34.81s-17.37,1.45-25.26-3.94l19.57-38.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M599.21,922.35s14.35,7,23.14,28.86.77,31.2-8.69,32-23.46-.19-37.52-14.75S580.52,913.91,599.21,922.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M586.76,957.69S577.43,926,605,927.17l6.23,4.9s11.09-16.65-5-25.82S564.89,903,556.56,925s-5,36.63,6.12,48,16.68-.49,16.68-.49-5.83-10.37-2.93-15.57,8.55,1.59,8.55,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M586.66,963.24s-12.84-13.66-17.54-3.87,12.77,12.21,19.36,12.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M520.28,1040.43l97.16,96.81-14.19,14.35-98.31-96.22a6,6,0,0,1-.75-7.7c1.68-2.48,4.72-5.52,10.16-8.22A5.16,5.16,0,0,1,520.28,1040.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M639.1,1171.2,629.43,1156a15.67,15.67,0,0,0-6.85,7.2l15.3,9.22A.9.9,0,0,0,639.1,1171.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M617.44,1137.24a24.87,24.87,0,0,0-14.19,14.35l19.33,11.65a15.67,15.67,0,0,1,6.85-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M515.71,1044.38a.38.38,0,0,1,.61-.43L609,1136.7a.37.37,0,0,1,0,.53.38.38,0,0,1-.54,0l-92.7-92.74A.28.28,0,0,1,515.71,1044.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M509.91,1049.52a.36.36,0,0,1,.07-.43.38.38,0,0,1,.54,0l92.71,92.74a.4.4,0,0,1,0,.54.38.38,0,0,1-.54,0L510,1049.62A.23.23,0,0,1,509.91,1049.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M620.77,1134.94l-19.89-19.17-27.51,11.62s-27.39,4.25-43.06,0l-15.68-4.24-35.42-11-5.56,15.73a9.44,9.44,0,0,0,3.46,10.87,61.82,61.82,0,0,0,8.94,5.57c4.67,2,115-1.41,115-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M968.39,862.5l-.35,0L956.15,861a2.89,2.89,0,0,1-2.47-2.26l-1.85-8.66A45.42,45.42,0,0,1,941,844l-8.38,2.89a2.9,2.9,0,0,1-3.21-.94L922,836.51a2.9,2.9,0,0,1-.15-3.34l4.82-7.44a45.14,45.14,0,0,1-3.36-12l-8-3.87a2.88,2.88,0,0,1-1.6-2.94L915.15,795a2.88,2.88,0,0,1,2.26-2.47l8.66-1.86a45.12,45.12,0,0,1,6.14-10.88l-2.9-8.38a2.88,2.88,0,0,1,1-3.21l9.42-7.38a2.89,2.89,0,0,1,3.34-.16l7.45,4.82a45.44,45.44,0,0,1,12-3.36l3.87-8a2.88,2.88,0,0,1,2.94-1.6L981.2,754a2.89,2.89,0,0,1,2.47,2.26l1.85,8.66a45.12,45.12,0,0,1,10.88,6.14l8.38-2.9a2.88,2.88,0,0,1,3.21,1l7.39,9.42a2.92,2.92,0,0,1,.15,3.35l-4.82,7.44a45.07,45.07,0,0,1,3.36,12l8,3.87a2.88,2.88,0,0,1,1.6,2.94L1022.2,820a2.89,2.89,0,0,1-2.26,2.47l-8.66,1.86a44.87,44.87,0,0,1-6.14,10.87l2.9,8.38a2.88,2.88,0,0,1-.95,3.21l-9.42,7.39a2.89,2.89,0,0,1-3.34.15l-7.45-4.81a45.82,45.82,0,0,1-12,3.36l-3.87,8A2.89,2.89,0,0,1,968.39,862.5Zm-10.86-5.44,10.13,1.22,4.48-9.19,1.13-.13a41.43,41.43,0,0,0,12.92-3.61l1-.48,8.59,5.56,8-6.3-3.35-9.67.71-.89a41.45,41.45,0,0,0,6.6-11.69l.39-1.07,10-2.14,1.23-10.14-9.2-4.47-.12-1.13a41.41,41.41,0,0,0-3.61-12.93l-.48-1,5.56-8.6-6.3-8-9.67,3.35-.89-.71a41.45,41.45,0,0,0-11.69-6.6L982,768l-2.15-10-10.13-1.23-4.48,9.2-1.13.12a41.43,41.43,0,0,0-12.92,3.61l-1,.48-8.59-5.56-8,6.3,3.35,9.68-.71.88a41.45,41.45,0,0,0-6.6,11.69l-.39,1.07-10,2.15-1.23,10.13,9.2,4.48.12,1.13A41.56,41.56,0,0,0,930.84,825l.48,1-5.56,8.59,6.3,8,9.67-3.35.89.72a41.18,41.18,0,0,0,11.69,6.59l1.07.39Zm37.6-6.09h0ZM917.2,795.24h0Zm15.6-23.8h0Zm36.11,66.9a31.71,31.71,0,0,1-3.75-.23,31,31,0,0,1-15.25-6.27,2.06,2.06,0,0,1,2.53-3.26,26.73,26.73,0,1,0-10.28-18.72,2.06,2.06,0,0,1-4.1.38,31,31,0,1,1,30.85,28.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M968.68,820.22A12.71,12.71,0,0,1,956.83,803h0a12.68,12.68,0,1,1,11.85,17.27Zm-8-15.79a8.58,8.58,0,1,0,4.53-4.75,8.53,8.53,0,0,0-4.53,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M789.41,589.21a1,1,0,0,1-.82-1.65c.83-1.11,1.7-2.2,2.58-3.27a1,1,0,1,1,1.59,1.31c-.86,1-1.71,2.12-2.53,3.2A1,1,0,0,1,789.41,589.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M957.51,626.23a1,1,0,0,1-1-.82c-.56-2.59-1.24-5.19-2-7.72a1,1,0,0,1,2-.6c.8,2.58,1.5,5.24,2.07,7.89a1,1,0,0,1-.79,1.22A.78.78,0,0,1,957.51,626.23Zm-6.77-20a1,1,0,0,1-.93-.59c-1.13-2.4-2.37-4.78-3.7-7.08a1,1,0,0,1,.38-1.41,1,1,0,0,1,1.4.38c1.36,2.35,2.63,4.79,3.78,7.23a1,1,0,0,1-.49,1.37A1,1,0,0,1,950.74,606.2Zm-11-18a1,1,0,0,1-.81-.4c-1.63-2.09-3.36-4.14-5.16-6.09a1,1,0,0,1,1.52-1.4c1.83,2,3.61,4.09,5.27,6.23a1,1,0,0,1-.18,1.44A1,1,0,0,1,939.69,588.17ZM801,576.49a1,1,0,0,1-.76-.34,1,1,0,0,1,.06-1.45c2-1.83,4.1-3.59,6.25-5.24a1,1,0,1,1,1.26,1.63c-2.1,1.62-4.16,3.34-6.12,5.13A1,1,0,0,1,801,576.49ZM925,573a1,1,0,0,1-.65-.24c-2-1.67-4.2-3.28-6.39-4.78a1,1,0,0,1-.26-1.43,1,1,0,0,1,1.43-.27c2.23,1.53,4.43,3.18,6.52,4.89a1,1,0,0,1,.14,1.45A1,1,0,0,1,925,573Zm-106.85-9a1,1,0,0,1-.51-1.93c2.35-1.34,4.79-2.6,7.24-3.74a1,1,0,0,1,.87,1.87c-2.4,1.11-4.79,2.34-7.09,3.66A1.06,1.06,0,0,1,818.1,564.05Zm89.1-2.49a1,1,0,0,1-.46-.11c-2.37-1.18-4.83-2.27-7.29-3.24a1,1,0,0,1,.76-1.92c2.52,1,5,2.11,7.45,3.32a1,1,0,0,1-.46,1.95Zm-69.69-5.88a1,1,0,0,1-.3-2c2.6-.79,5.26-1.47,7.9-2a1,1,0,0,1,.43,2c-2.59.54-5.19,1.21-7.73,2A1,1,0,0,1,837.51,555.68Zm49.83-1.36-.24,0c-2.58-.63-5.21-1.15-7.83-1.56a1,1,0,1,1,.31-2c2.68.41,5.37.95,8,1.59a1,1,0,0,1-.24,2Zm-29-2.47a1,1,0,0,1-1-1,1,1,0,0,1,1-1.1c2.7-.18,5.45-.26,8.16-.21a1,1,0,0,1,1,1,1.07,1.07,0,0,1-1,1c-2.65,0-5.33,0-8,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M959.61,643.35a1,1,0,0,1-1-1c0-1.34-.11-2.71-.21-4.07a1,1,0,0,1,2-.15c.11,1.39.18,2.78.22,4.15a1,1,0,0,1-1,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M932.6,712.6a1,1,0,0,1-.72-.29,1,1,0,0,1,0-1.46c.95-1,1.89-2,2.79-3a1,1,0,0,1,1.46-.07,1,1,0,0,1,.07,1.45c-.92,1-1.88,2-2.85,3A1,1,0,0,1,932.6,712.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M864.85,741h0c-2.67,0-5.36-.12-8-.35a1,1,0,0,1-.94-1.12,1,1,0,0,1,1.12-.93c2.6.22,5.24.33,7.84.34a1,1,0,0,1,0,2.06Zm12.87-.85a1,1,0,0,1-.14-2c2.59-.35,5.19-.82,7.73-1.38a1,1,0,0,1,.45,2c-2.6.58-5.26,1-7.9,1.41Zm-33.54-1.47-.23,0c-2.6-.59-5.2-1.29-7.74-2.09a1,1,0,1,1,.62-2c2.48.78,5,1.46,7.58,2a1,1,0,0,1-.23,2Zm53.72-3.58a1,1,0,0,1-.36-2c2.44-.9,4.87-1.93,7.24-3a1,1,0,1,1,.87,1.86c-2.41,1.14-4.9,2.19-7.39,3.11A.92.92,0,0,1,897.9,735.11Zm-73.39-3.18a1.12,1.12,0,0,1-.44-.09c-2.41-1.14-4.8-2.39-7.11-3.73a1,1,0,0,1,1-1.78c2.26,1.31,4.6,2.53,7,3.64a1,1,0,0,1,.49,1.37A1,1,0,0,1,824.51,731.93Zm92-6.17a1,1,0,0,1-.86-.47,1,1,0,0,1,.3-1.43c2.2-1.42,4.35-3,6.41-4.54a1,1,0,0,1,1.26,1.63c-2.1,1.62-4.31,3.19-6.55,4.64A1,1,0,0,1,916.48,725.76Zm-109.69-4.71a1,1,0,0,1-.63-.22c-2.1-1.63-4.16-3.37-6.12-5.18a1,1,0,1,1,1.4-1.52c1.92,1.77,3.93,3.48,6,5.08a1,1,0,0,1,.18,1.44A1,1,0,0,1,806.79,721.05Zm-14.9-14.51a1,1,0,0,1-.79-.37c-1.69-2-3.31-4.21-4.83-6.41a1,1,0,0,1,.26-1.43,1,1,0,0,1,1.43.26c1.49,2.15,3.08,4.26,4.73,6.27a1,1,0,0,1-.8,1.68Zm-11.38-17.41a1,1,0,0,1-.92-.56c-1.21-2.38-2.33-4.83-3.33-7.3a1,1,0,1,1,1.9-.78c1,2.42,2.08,4.82,3.27,7.15A1,1,0,0,1,781,689,.92.92,0,0,1,780.51,689.13Zm-7.33-19.47a1,1,0,0,1-1-.77c-.66-2.58-1.21-5.22-1.65-7.85a1,1,0,1,1,2-.34c.43,2.57,1,5.16,1.62,7.68a1,1,0,0,1-.75,1.25A.72.72,0,0,1,773.18,669.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M770.31,649a1,1,0,0,1-1-1c0-1.38,0-2.78,0-4.16a1.07,1.07,0,0,1,1-1,1,1,0,0,1,1,1c0,1.35,0,2.72,0,4.08a1,1,0,0,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M793,635a1.15,1.15,0,0,0,.48,1.23L805,643.85a60.17,60.17,0,0,0,2.8,19.32l-8.92,10.56a1.13,1.13,0,0,0-.11,1.31l8.49,14.25a1.16,1.16,0,0,0,1.21.54L822,687a60.7,60.7,0,0,0,15.65,11.67l1.16,13.78a1.14,1.14,0,0,0,.85,1l16.09,4.07a1.13,1.13,0,0,0,1.23-.48l7.58-11.56a60.46,60.46,0,0,0,19.32-2.81l10.55,8.92a1.13,1.13,0,0,0,1.32.11L910,703.23a1.13,1.13,0,0,0,.53-1.21l-2.81-13.53a60.1,60.1,0,0,0,11.66-15.65l13.79-1.16a1.13,1.13,0,0,0,1-.85l4.08-16.08a1.13,1.13,0,0,0-.48-1.23l-11.57-7.58a60.13,60.13,0,0,0-2.8-19.32l8.92-10.56a1.15,1.15,0,0,0,.11-1.32l-8.49-14.25a1.13,1.13,0,0,0-1.21-.53l-13.53,2.82a60.25,60.25,0,0,0-15.65-11.67l-1.16-13.78a1.13,1.13,0,0,0-.85-1l-16.08-4.08a1.16,1.16,0,0,0-1.23.48l-7.59,11.57a60.07,60.07,0,0,0-19.31,2.8l-10.56-8.92a1.16,1.16,0,0,0-1.32-.11l-14.25,8.49a1.14,1.14,0,0,0-.53,1.21l2.81,13.53a60.43,60.43,0,0,0-11.66,15.65L798,618.1a1.14,1.14,0,0,0-1,.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M865.6,661.17h0a16.19,16.19,0,0,1-11.51-4.78h0a16.27,16.27,0,0,1,11.52-27.77h0a16.28,16.28,0,0,1,0,32.55Zm0-29.46a13.18,13.18,0,0,0-9.33,22.5h0a13.1,13.1,0,0,0,9.32,3.87h0a13.19,13.19,0,0,0,0-26.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M866,686.54a41.69,41.69,0,0,1-35.79-20.31c-.14-.23-.27-.46-.4-.69a42.36,42.36,0,0,1-3-6.34v0c-.12-.32-.23-.65-.34-1l2.92-1a39.5,39.5,0,0,0,3.43,7.45h0a38.56,38.56,0,0,0,39.66,18.22,38,38,0,0,0,12.58-4.55l.52-.3a38.49,38.49,0,1,0-53.57-51.34l-2.72-1.46A41.57,41.57,0,1,1,866,686.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M822.42,758.84a.83.83,0,0,1,1,.2c.46.52.91,1.06,1.35,1.6a.83.83,0,0,1-.13,1.16.81.81,0,0,1-1.15-.13c-.43-.52-.86-1-1.31-1.54a.82.82,0,0,1,.08-1.16A.59.59,0,0,1,822.42,758.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M826.18,763.68a.81.81,0,0,1,1,.29c.78,1.13,1.51,2.32,2.19,3.51a.83.83,0,0,1-1.44.81c-.65-1.15-1.36-2.3-2.11-3.4a.82.82,0,0,1,.22-1.14Zm4,7.09h0a.8.8,0,0,1,1.09.4c.48,1,.92,2.07,1.32,3.11l.27.71a.83.83,0,1,1-1.55.57c-.08-.23-.17-.46-.26-.69-.39-1-.81-2-1.27-3A.82.82,0,0,1,830.18,770.77Zm2.8,7.64.13,0a.82.82,0,0,1,1,.57c.37,1.33.69,2.69.94,4a.82.82,0,1,1-1.61.31c-.25-1.3-.56-2.61-.91-3.9A.81.81,0,0,1,833,778.41Zm1.53,8a.79.79,0,0,1,.26-.08.82.82,0,0,1,.9.74c.15,1.36.24,2.75.27,4.13a.82.82,0,1,1-1.64,0c0-1.32-.12-2.67-.26-4A.81.81,0,0,1,834.51,786.4Zm.19,8.13a.85.85,0,0,1,.39-.07.82.82,0,0,1,.78.87c-.09,1.37-.22,2.76-.42,4.12a.82.82,0,0,1-1.63-.23c.19-1.32.32-2.66.4-4A.84.84,0,0,1,834.7,794.53Zm-1.15,8.06a.86.86,0,0,1,.53-.06.83.83,0,0,1,.62,1c-.31,1.34-.67,2.68-1.08,4a.83.83,0,0,1-1,.53.82.82,0,0,1-.53-1c.4-1.27.75-2.57,1-3.87A.84.84,0,0,1,833.55,802.59Zm-2.45,7.76a.82.82,0,0,1,1.11,1.06c-.52,1.27-1.1,2.54-1.72,3.76a.82.82,0,0,1-1.1.37.83.83,0,0,1-.37-1.11c.6-1.18,1.16-2.41,1.67-3.64A.84.84,0,0,1,831.1,810.35Zm-3.67,7.26a.83.83,0,0,1,.78,0,.85.85,0,0,1,.27,1.14c-.72,1.17-1.5,2.33-2.31,3.43a.82.82,0,0,1-1.33-1c.79-1.07,1.54-2.19,2.23-3.32A.85.85,0,0,1,827.43,817.61Zm-44.61,23.61a.85.85,0,0,1,.39-.07c1.32.06,2.67.07,4,0a.82.82,0,0,1,.85.79.83.83,0,0,1-.79.86c-1.38,0-2.77,0-4.14,0a.83.83,0,0,1-.31-1.57Zm39.8-17.05a.83.83,0,0,1,.89.13.82.82,0,0,1,.08,1.16c-.9,1-1.85,2-2.84,3a.82.82,0,0,1-1.16,0,.83.83,0,0,1,0-1.17c.95-.92,1.88-1.9,2.75-2.91A.9.9,0,0,1,822.62,824.17ZM791,840.93a1.17,1.17,0,0,1,.25-.07c1.32-.15,2.65-.37,4-.63a.82.82,0,1,1,.33,1.61c-1.35.27-2.73.5-4.09.66a.83.83,0,0,1-.45-1.57Zm25.86-11.07a.84.84,0,0,1,1,.22.82.82,0,0,1-.11,1.16c-1.06.88-2.16,1.72-3.29,2.51a.83.83,0,0,1-1.15-.21.82.82,0,0,1,.2-1.14c1.1-.77,2.17-1.58,3.19-2.43Zm-17.88,9.45.12,0c1.27-.37,2.55-.8,3.79-1.28a.84.84,0,0,1,1.07.48.83.83,0,0,1-.48,1.06c-1.29.49-2.61.94-3.92,1.32a.83.83,0,0,1-.58-1.54Zm11.21-4.8a.82.82,0,0,1,.76,1.46c-1.19.69-2.42,1.34-3.66,1.93h0a.82.82,0,0,1-.7-1.49c1.2-.58,2.39-1.2,3.54-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M776.68,840.55a.78.78,0,0,1,.48-.07c.67.12,1.33.22,2,.31a.82.82,0,1,1-.21,1.63c-.69-.09-1.38-.2-2.07-.32a.81.81,0,0,1-.67-1A.83.83,0,0,1,776.68,840.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M744,819.46a.82.82,0,0,1,1,.28q.57.84,1.17,1.65a.83.83,0,0,1-.18,1.16.82.82,0,0,1-1.15-.18c-.41-.56-.81-1.13-1.21-1.71a.82.82,0,0,1,.23-1.14A.39.39,0,0,1,744,819.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M764.1,746.65c.73-.34,1.44-.65,2.18-.95a.82.82,0,0,1,1.08.44.84.84,0,0,1-.45,1.08c-.72.29-1.45.59-2.12.92l-1.47.72a.83.83,0,0,1-1.1-.36.82.82,0,0,1,.36-1.11Zm-5,2.68a.82.82,0,0,1,.78,1.45c-1.12.69-2.22,1.42-3.27,2.2a.82.82,0,0,1-1.15-.18.83.83,0,0,1,.17-1.15c1.1-.8,2.23-1.56,3.39-2.27Zm10.9-5,.1,0c1.28-.41,2.61-.78,3.92-1.09a.82.82,0,0,1,1,.61.81.81,0,0,1-.61,1c-1.28.3-2.55.66-3.8,1.06a.82.82,0,0,1-1-.54A.81.81,0,0,1,770,744.34Zm-17.36,9.72a.84.84,0,0,1,1,.21.82.82,0,0,1-.09,1.16c-1,.86-1.95,1.76-2.87,2.7a.82.82,0,1,1-1.17-1.16c1-1,1.94-1.9,3-2.78A.59.59,0,0,1,752.65,754.06Zm25.16-11.55.23-.07c1.34-.2,2.7-.35,4.05-.44a.83.83,0,0,1,.11,1.65c-1.3.08-2.62.23-3.92.42a.81.81,0,0,1-.93-.69A.82.82,0,0,1,777.81,742.51ZM747,759.77a.82.82,0,0,1,1,1.27c-.84,1-1.64,2.06-2.4,3.13a.82.82,0,0,1-1.15.19.81.81,0,0,1-.19-1.14c.78-1.11,1.61-2.2,2.48-3.23A.74.74,0,0,1,747,759.77ZM785.8,742a.86.86,0,0,1,.36-.08c1.35,0,2.72.1,4.07.23a.82.82,0,1,1-.16,1.63c-1.3-.12-2.63-.19-3.93-.21a.83.83,0,0,1-.34-1.57Zm-43.38,24.34a.82.82,0,0,1,1.06,1.16c-.67,1.13-1.3,2.29-1.87,3.47a.82.82,0,1,1-1.48-.72c.59-1.22,1.24-2.42,1.93-3.58A.87.87,0,0,1,742.42,766.31Zm-3.51,7.19a.86.86,0,0,1,.65,0,.83.83,0,0,1,.46,1.07c-.47,1.22-.91,2.47-1.29,3.72a.82.82,0,1,1-1.57-.47c.39-1.3.84-2.6,1.33-3.85A.84.84,0,0,1,738.91,773.5Zm-2.32,7.67a.77.77,0,0,1,.52-.06.82.82,0,0,1,.63,1c-.27,1.28-.5,2.58-.67,3.88a.82.82,0,1,1-1.63-.22c.17-1.34.41-2.69.7-4A.8.8,0,0,1,736.59,781.17Zm-1.05,7.94a.72.72,0,0,1,.39-.08.82.82,0,0,1,.78.86c-.07,1.32-.09,2.64-.05,4a.82.82,0,0,1-1.64,0c0-1.35,0-2.72,0-4.08A.82.82,0,0,1,735.54,789.11Zm.24,8A.72.72,0,0,1,736,797a.82.82,0,0,1,.91.73c.15,1.3.35,2.6.6,3.89a.82.82,0,0,1-1.62.31c-.26-1.32-.46-2.68-.61-4A.83.83,0,0,1,735.78,797.11Zm1.53,7.86.12-.05a.83.83,0,0,1,1,.57c.35,1.26.76,2.52,1.21,3.75a.82.82,0,1,1-1.54.57c-.47-1.27-.89-2.57-1.26-3.87A.83.83,0,0,1,737.31,805Zm2.77,7.51a.82.82,0,0,1,1.09.4l.06.14c.54,1.14,1.12,2.27,1.74,3.37a.83.83,0,0,1-1.44.81c-.64-1.14-1.24-2.31-1.79-3.49l-.06-.14A.81.81,0,0,1,740.08,812.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M793.82,742.74a.75.75,0,0,1,.49-.06c.69.12,1.37.25,2.05.41a.81.81,0,0,1,.63,1,.82.82,0,0,1-1,.62c-.66-.14-1.32-.28-2-.39a.83.83,0,0,1-.66-1A.84.84,0,0,1,793.82,742.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M798.33,756.46a.6.6,0,0,0-.68.12l-5.12,5.14a31.41,31.41,0,0,0-10.21-.59l-4.48-5.7a.59.59,0,0,0-.67-.19L769,758.09a.6.6,0,0,0-.4.57l0,7.25a31.38,31.38,0,0,0-7.65,6.8l-7.2-.85a.58.58,0,0,0-.6.33L749.34,780a.59.59,0,0,0,.11.68l5.14,5.11A31.47,31.47,0,0,0,754,796l-5.7,4.48a.61.61,0,0,0-.19.67l2.86,8.21a.59.59,0,0,0,.56.4l7.25,0a31.17,31.17,0,0,0,6.81,7.64l-.86,7.21a.58.58,0,0,0,.33.6l7.83,3.79a.59.59,0,0,0,.68-.11l5.12-5.15a31.69,31.69,0,0,0,10.21.6l4.49,5.69a.59.59,0,0,0,.66.2l8.22-2.86a.59.59,0,0,0,.4-.56l0-7.25a31.77,31.77,0,0,0,7.64-6.81l7.2.86a.61.61,0,0,0,.61-.33l3.78-7.83a.59.59,0,0,0-.11-.68l-5.14-5.12a31.45,31.45,0,0,0,.59-10.22l5.7-4.48a.57.57,0,0,0,.19-.66l-2.86-8.22a.59.59,0,0,0-.56-.4l-7.25,0a31.35,31.35,0,0,0-6.81-7.64l.86-7.2a.6.6,0,0,0-.33-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M782,785a8.56,8.56,0,0,1,10.74,3,8.55,8.55,0,0,1-14.28,9.4,8.56,8.56,0,0,1,2.44-11.84h0A7.45,7.45,0,0,1,782,785Zm6.51,14a6.41,6.41,0,0,0,.88-.5,6.9,6.9,0,0,0,2-9.56,6.92,6.92,0,0,0-9.56-2h0a6.9,6.9,0,0,0,6.7,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M776.3,773.15c.67-.31,1.37-.59,2.08-.84h0l.86-.28a22,22,0,0,1,3.07-.7h.11l.27,0,.21,0a.85.85,0,0,1,.85.47,1,1,0,0,1,.07.25.83.83,0,0,1-.72.92,20.06,20.06,0,0,0-15.71,11.24,20,20,0,0,0-.89,15.4c.23.66.49,1.3.78,1.93a20.16,20.16,0,0,0,37.31-15.17,17.55,17.55,0,0,0-.77-1.9,20.15,20.15,0,0,0-5.33-6.95.74.74,0,0,1-.22-.28.83.83,0,0,1,1.28-1,21.83,21.83,0,0,1,5.76,7.51c.31.67.59,1.35.84,2a21.82,21.82,0,0,1-40.36,16.42,22.12,22.12,0,0,1-.85-2.08,21.83,21.83,0,0,1,11.36-26.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1385.62,
    y: 397.98,
    width: 556.27,
    height: 369.25,
    rx: 25.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1908,749.08H1417.9a17.68,17.68,0,0,1-17.66-17.66V433.79a17.68,17.68,0,0,1,17.66-17.66H1908a17.68,17.68,0,0,1,17.66,17.66V731.42A17.68,17.68,0,0,1,1908,749.08ZM1417.9,418.19a15.62,15.62,0,0,0-15.6,15.6V731.42a15.62,15.62,0,0,0,15.6,15.6H1908a15.61,15.61,0,0,0,15.6-15.6V433.79a15.61,15.61,0,0,0-15.6-15.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1644.5,
    y: 233.92,
    width: 2.06,
    height: 490.97,
    transform: "translate(1161.48 2123.58) rotate(-89.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1507.26,
    y: 417.64,
    width: 2.06,
    height: 329.93,
    transform: "translate(-1.78 4.64) rotate(-0.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1818.08,
    y: 416.6,
    width: 2.06,
    height: 329.93,
    transform: "translate(-1.78 5.59) rotate(-0.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1716.82,
    y: 416.6,
    width: 2.06,
    height: 329.93,
    transform: "translate(-1.78 5.28) rotate(-0.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1611.72,
    y: 416.6,
    width: 2.06,
    height: 329.93,
    transform: "translate(-1.78 4.96) rotate(-0.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 1412.95,
    y: 496.76,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 1412.95,
    y: 530.41,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1412.95,
    y: 566.05,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1412.95,
    y: 607.01,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1412.95,
    y: 676.29,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1516.07,
    y: 497.9,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1516.07,
    y: 531.54,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 1516.07,
    y: 608.14,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 1516.07,
    y: 641.78,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1516.07,
    y: 677.42,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1621.74,
    y: 497.9,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1621.74,
    y: 531.54,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 1621.74,
    y: 567.18,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1621.74,
    y: 641.78,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1621.74,
    y: 677.42,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 1723.4,
    y: 500.06,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 1723.4,
    y: 569.34,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 1723.4,
    y: 610.3,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 1723.4,
    y: 643.94,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1723.4,
    y: 679.58,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 1826.42,
    y: 500.06,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 1826.42,
    y: 533.7,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 1826.42,
    y: 610.3,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 1826.42,
    y: 679.58,
    width: 88.9,
    height: 11.45,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1486.07,408.2a1,1,0,0,1-.31-2l194.72-60.86.31.1,176.28,56a1,1,0,0,1,.67,1.3,1,1,0,0,1-1.29.67l-176-55.92-194.1,60.67A1.12,1.12,0,0,1,1486.07,408.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-116",
    cx: 1683.16,
    cy: 353.11,
    r: 12.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1434.78,434.45h43.55a2.25,2.25,0,0,1,2.25,2.25v14A10.32,10.32,0,0,1,1470.26,461H1438a10.32,10.32,0,0,1-10.32-10.32V441.5A7.05,7.05,0,0,1,1434.78,434.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1540.26,434.45h43.55a2.25,2.25,0,0,1,2.25,2.25v14A10.32,10.32,0,0,1,1575.74,461h-32.22a10.32,10.32,0,0,1-10.32-10.32V441.5A7.05,7.05,0,0,1,1540.26,434.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1644.66,434.45h43.55a2.25,2.25,0,0,1,2.25,2.25v14A10.32,10.32,0,0,1,1680.14,461h-32.22a10.32,10.32,0,0,1-10.32-10.32V441.5A7.05,7.05,0,0,1,1644.66,434.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1750.29,434.45h43.55a2.25,2.25,0,0,1,2.25,2.25v14A10.32,10.32,0,0,1,1785.77,461h-32.22a10.32,10.32,0,0,1-10.32-10.32V441.5A7.05,7.05,0,0,1,1750.29,434.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M1848.41,434.45H1892a2.25,2.25,0,0,1,2.25,2.25v14A10.32,10.32,0,0,1,1883.89,461h-32.22a10.32,10.32,0,0,1-10.32-10.32V441.5A7.05,7.05,0,0,1,1848.41,434.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1781.69,615.18c-.37,1.17,3.9,3,6.41-1.83.09-2.3,1.49-12.14.11-14-7.3-10-21.47-22.44-21.47-22.44a3.37,3.37,0,0,0-.42,4.68l6.87,7.16c-1.43,2.6-3.19,4.79-4,7.93a9.66,9.66,0,0,0,1,7.09c1.21,2.17,2.85,5,4.41,7.21A9.5,9.5,0,0,0,1781.69,615.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1776.2,593.38l6.26,5.31,2,5.29-5.59,6.19s-1.87-10.49-3.27-12.76S1774.9,594.05,1776.2,593.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M1904.69,1006.1s1.58,9,2.36,17.82a6.11,6.11,0,0,1-5.84,6.62c-11.81.49-37.06,1.45-46.12,1a2,2,0,0,1-1.75-2.72h0a4.44,4.44,0,0,1,2.27-2.4l41.72-19.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1906,1000.84l-1.27,10.71s-7.31,3.4-12.3-.43l3-11.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1905,799.45c.55,2.8,3,139.6-11.67,200.9a2.07,2.07,0,0,0,1.22,2.42,36.2,36.2,0,0,0,11.91,2.42,3.57,3.57,0,0,0,3.55-2.57c4.18-14.22,24.21-85.49,26.82-153.56,2.92-76.07,0-2.59,0-2.59l-1.71-47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1952.67,1010.77s2.52,4.52,5,16.54a3.73,3.73,0,0,1-3.28,4.46c-3.9.38-9.9.88-14.71.84a3.7,3.7,0,0,1-3.67-4.14c.53-4.39,2.19-11.58,7.31-17.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1954.89,997l-3,16.2s-2.94,2.18-8.75.6l1.42-17.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1962.91,803.65c12,72.17-2.6,178.39-7.5,199.18a3.25,3.25,0,0,1-2.62,2.46,21.75,21.75,0,0,1-9.36-.38,3,3,0,0,1-2.13-2.73c-.66-16.81.52-120-10.62-160.76a9.25,9.25,0,0,0-3.57-5.11l-21.63-15.38-1.66-24.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1886.7,666.89c35.84-.59,75.39,9.41,75.39,9.41,10.68,62.34,1.87,134.24,1.87,134.24-27.75,7.27-59-4.45-59-4.45-4.61-26.06-26.13-99.38-26.13-99.38-17.51-2.18-31.93-7.23-43.81-13.91,9.06-10.5,13.33-23.87,15.18-31.77C1862.83,665,1875.65,667.07,1886.7,666.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M1780.84,614.1a6.85,6.85,0,0,1,8-2.24c5.28,22.28,32.93,40.34,61.34,49.17-1.85,7.9-6.12,21.27-15.18,31.77C1787.81,666.29,1780.84,614.1,1780.84,614.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1948.34,711l13.75-34.7s33.47,22.75,39,51.59a79.07,79.07,0,0,0-29.1,7.8C1969.49,722.07,1948.34,711,1948.34,711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M1923,637.79l11.4,33a1.19,1.19,0,0,1-.54,1.43c-3.11,1.72-14.31,6.69-27.81-1.87a5.58,5.58,0,0,1-2.57-4l-3.7-28.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1898.19,607.25s-12.52,23.58-10.91,33.1,17.12,8.84,30.67,1.1l9.47-25.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1917.35,629a1,1,0,0,1-.42-1.42,25.4,25.4,0,0,0,3.48-7.4s2.25-1.44-5.73-3.35-19.88-4.87-22.38-11.67c-2.44-6.62,4-23.28,14.19-10a1,1,0,0,0,1.54,0c1.68-2.19,6.09-6.71,12.2-4,5.73,2.57,6.37,6.77,6.29,8.88a1,1,0,0,0,1.15,1c2.89-.55,9.84-1,13.08,6.1,2.67,5.87.94,9.19-.65,10.81a1,1,0,0,0,.42,1.61c1.9.59,4.36,2.2,4.11,6.66-.34,6.16-7.23,5.61-9.19,5.33a1,1,0,0,0-.86.31c-1.68,1.86-9.26,9.76-17.46,10.71a1,1,0,0,1-1-1.29l3.55-10.32a1,1,0,0,0-.53-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1915.93,630.42s8.91-6.12,9.56-1-8,7.46-12.32,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1972,735.69s11.7,52.78,1.1,82.46c13,6,10.59,4.89,10.59,4.89s25.71-75.11,17.41-95.15C1984.71,726.15,1976.59,730.55,1972,735.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1973.07,818.15s-6.7,8.66-6.16,12.12.66,4.85.66,4.85,3.37-2.3,3.16-5.24c-.47,9.33-3.6,20-.75,19.43s17.54-14.06,14.21-28.5C1976.65,815.56,1974.54,816.13,1973.07,818.15Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarImg1);
export default __webpack_public_path__ + "static/media/sugar_img_1.3be990c11371b7298781bff1107df77c.svg";
export { ForwardRef as ReactComponent };